export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_GET_ME = 'AUTH_GET_ME';
export const AUTH_SELECT_TENANT = 'AUTH_SELECT_TENANT'
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';
export const PRINTER_LIST = 'PRINTER_LIST';
export const PRINTER_ADD_EQUIP = 'PRINTER_ADD_EQUIP';
export const PRINTER_CLEAR_EQUIP = 'PRINTER_CLEAR_EQUIP';
export const AUTH_CHANGE_PROFILE_PICTURE_SUCCESS = 'AUTH_CHANGE_PROFILE_PICTURE_SUCCESS';
export const AUTH_CHANGE_NAME_SUCCESS = 'AUTH_CHANGE_NAME_SUCCESS';
export const AUTH_CHANGE_PASSWORD_SUCCESS = 'AUTH_CHANGE_PASSWORD_SUCCESS';
export const AUTH_CHANGE_RECEIVE_AUTOMATIC_EMAILS_SUCCESS = 'AUTH_CHANGE_RECEIVE_AUTOMATIC_EMAILS_SUCCESS';
export const AUTH_CHANGE_SHOW_SERVICE_REPORT_COORDINATES_SUCCESS = 'AUTH_CHANGE_SHOW_SERVICE_COORDINATES_SUCCESS';

// ----- drawer -----------------------------------------------------------------------------------
export const SET_DRAWER_OPEN = 'SET_DRAWER_OPEN';

// ----- users -----------------------------------------------------------------------------------
export const REQUEST_USERS_START = 'REQUEST_USERS_START';
export const SET_USERS_FILTER = '[USERS] SET_USERS_FILTER';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const REQUEST_USERS_FAIL = 'REQUEST_USERS_FAIL';
export const DELETE_USERS_SUCCESS = 'DELETE_USERS_SUCCESS';
export const UPDATE_USERS_SUCCESS = 'UPDATE_USERS_SUCCESS';
export const POST_USERS_SUCCESS = 'POST_USERS_SUCCESS';
export const FETCH_USER_BY_ID_SUCCESS = 'FETCH_USER_BY_ID_SUCCESS';
export const INVITE_SIGNUP_SUCCESS = 'INVITE_SIGNUP_SUCCESS'
export const INVITE_SIGNUP_BY_TENANT_SUCCESS = 'INVITE_SIGNUP_BY_TENANT_SUCCESS'
export const INVITE_ADD_TENANT_SUCCESS = 'INVITE_ADD_TENANT_SUCCESS';
export const INVITE_CREATE_USER_SUCCESS = 'INVITE_CREATE_USER_SUCCESS';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ACTIVATE_SUCCESS = 'FORGOT_PASSWORD_ACTIVATE_SUCCESS';
// Tokens
export const REQUEST_USERS_INVITATIONS_START = 'REQUEST_USERS_INVITATIONS_START';
export const FETCH_USERS_INVITATIONS_SUCCESS = 'FETCH_USERS_INVITATIONS_SUCCESS';
export const REQUEST_USERS_INVITATIONS_FAIL = 'REQUEST_USERS_INVITATIONS_FAIL';
// Method to superadmin
export const REQUEST_UPDATE_USER_BY_SUPERADMIN_START = 'REQUEST_UPDATE_USER_BY_SUPERADMIN_START';
export const UPDATE_USER_BY_SUPERADMIN_SUCCESS = 'FETCH_UPDATE_USER_BY_SUPERADMIN_SUCCESS';
export const REQUEST_UPDATE_USER_BY_SUPERADMIN_FAIL = 'REQUEST_UPDATE_USER_BY_SUPERADMIN_FAIL';

// ----- actions -----------------------------------------------------------------------------------
export const GET_USER = '[ACTION_USER]GET_USER';
export const REQUEST_ACTIONS_START = 'REQUEST_ACTIONS_START';
export const FETCH_ACTIONS_SUCCESS = 'FETCH_ACTIONS_SUCCESS';
export const FETCH_ACTIONS_BY_ID_SUCCESS = 'FETCH_ACTIONS_BY_ID_SUCCESS';
export const REQUEST_ACTIONS_FAIL = 'REQUEST_ACTIONS_FAIL';
export const DELETE_ACTIONS_SUCCESS = 'DELETE_ACTIONS_SUCCESS';
export const UPDATE_ACTIONS_SUCCESS = 'UPDATE_ACTIONS_SUCCESS';
export const POST_ACTIONS_SUCCESS = 'POST_ACTIONS_SUCCESS';
export const CHECK_DELETE_ACTIONS_SUCCESS = 'CHECK_DELETE_ACTIONS_SUCCESS';
export const SET_ACTIONS_FILTER = 'SET_ACTIONS_FILTER';
export const ACTIONS_CHANGE_STATUS_START = 'ACTIONS_CHANGE_STATUS_START';
export const ACTIONS_CHANGE_STATUS_SUCCESS = 'ACTIONS_CHANGE_STATUS_SUCCESS';
export const ACTIONS_CHANGE_STATUS_FAIL = 'ACTIONS_CHANGE_STATUS_FAIL';
export const ACTIONS_ADD_COMPLETE_ACTION_FILE = 'ACTIONS_ADD_COMPLETE_ACTION_FILE';
export const ACTIONS_EDIT_COMPLETE_ACTION_FILE = 'ACTIONS_EDIT_COMPLETE_ACTION_FILE';
export const ACTIONS_DELETE_COMPLETE_ACTION_FILE = 'ACTIONS_DELETE_COMPLETE_ACTION_FILE';
export const ACTIONS_CLEAR_COMPLETE_ACTION_FILES = 'ACTIONS_CLEAR_COMPLETE_ACTION_FILES';
export const ACTIONS_FETCH_COMPANIES_FOR_FILTERS_START = 'ACTIONS_FETCH_COMPANIES_FOR_FILTERS_START';
export const ACTIONS_FETCH_COMPANIES_FOR_FILTERS_SUCCESS = 'ACTIONS_FETCH_COMPANIES_FOR_FILTERS_SUCCESS';
export const ACTIONS_FETCH_COMPANIES_FOR_FILTERS_FAIL = 'ACTIONS_FETCH_COMPANIES_FOR_FILTERS_FAIL';


// Filters
export const FILTER_ACTION_USERS = 'FILTER_ACTION_USERS';
export const FILTER_ACTION_USERS_REMOVE = 'FILTER_ACTION_USERS_REMOVE';
export const FILTER_ACTION_USERS_REMOVE_STATE = 'FILTER_ACTION_USERS_REMOVE_STATE';
export const FILTER_ACTION_EQUIPMENTS = 'FILTER_ACTION_EQUIPMENTS';
export const FILTER_ACTION_EQUIPMENTS_REMOVE = 'FILTER_ACTION_EQUIPMENTS_REMOVE'
export const FILTER_ACTION_PLACES = 'FILTER_ACTION_PLACES';
export const FILTER_ACTION_PLACES_REMOVE = 'FILTER_ACTION_PLACES_REMOVE';
export const FILTER_ACTION_AREAS = 'FILTER_ACTION_AREAS';
export const FILTER_ACTION_AREAS_REMOVE = 'FILTER_ACTION_AREAS_REMOVE';
export const FILTER_ACTION_STATUS = 'FILTER_ACTION_STATUS';
export const FILTER_ACTION_STATUS_REMOVE = 'FILTER_ACTION_STATUS_REMOVE';
export const FILTER_ACTION_START_DATE = 'FILTER_ACTION_START_DATE';
export const FILTER_ACTION_START_DATE_REMOVE = 'FILTER_ACTION_START_DATE_REMOVE';
export const FILTER_ACTION_END_DATE = 'FILTER_ACTION_END_DATE';
export const FILTER_ACTION_END_DATE_REMOVE = 'FILTER_ACTION_END_DATE_REMOVE';
export const FILTER_ACTION_COMPANIES = 'FILTER_ACTION_COMPANIES';
export const FILTER_ACTION_COMPANIES_REMOVE = 'FILTER_ACTION_COMPANIES_REMOVE';
export const FILTER_ACTION_CLEAR = 'FILTER_ACTION_CLEAR';


// ----- areas -----------------------------------------------------------------------------------
export const REQUEST_AREAS_START = 'REQUEST_AREAS_START';
export const FETCH_AREAS_SUCCESS = 'FETCH_AREAS_SUCCESS';
export const REQUEST_AREAS_FAIL = 'REQUEST_AREAS_FAIL';
export const DELETE_AREAS_SUCCESS = 'DELETE_AREAS_SUCCESS';
export const UPDATE_AREAS_SUCCESS = 'UPDATE_AREAS_SUCCESS';
export const POST_AREAS_SUCCESS = 'POST_AREAS_SUCCESS';
export const CHECK_DELETE_AREAS_SUCCESS = 'CHECK_DELETE_AREAS_SUCCESS';

// ----- sites -----------------------------------------------------------------------------------
export const REQUEST_SITES_START = 'REQUEST_SITES_START';
export const FETCH_SITES_SUCCESS = 'FETCH_SITES_SUCCESS';
export const REQUEST_SITES_FAIL = 'REQUEST_SITES_FAIL';
export const DELETE_SITES_SUCCESS = 'DELETE_SITES_SUCCESS';
export const UPDATE_SITES_SUCCESS = 'UPDATE_SITES_SUCCESS';
export const POST_SITES_SUCCESS = 'POST_SITES_SUCCESS';
export const CHECK_DELETE_SITES_SUCCESS = 'CHECK_DELETE_SITES_SUCCESS';
export const FETCH_ALL_SITES_SUCCESS = 'FETCH_ALL_SITES_SUCCESS';
export const SELECT_SITE_PLACES = 'SELECT_SITE_PLACES';
export const FILTER_SITES_REMOVE = 'FILTER_SITES_REMOVE';
export const SET_SITE_PLACES = 'SET_SITE_PLACES';
export const SELECT_SITE_QUESTIONS = 'SELECT_SITE_QUESTIONS';
export const SELECT_DEFAULT_PLACES = 'SELECT_DEFAULT_PLACES';
export const SELECT_DEFAULT_QUESTIONS = 'SELECT_DEFAULT_QUESTIONS';
export const SET_SELECTED_SITES = 'SET_SELECTED_SITES';

// ----- roles ---------------------------------------------------------------------------------
export const REQUEST_ROLES_START = 'REQUEST_ROLES_START';
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS';
export const REQUEST_ROLES_FAIL = 'REQUEST_ROLES_FAIL';
export const DELETE_ROLES_SUCCESS = 'DELETE_ROLES_SUCCESS';
export const UPDATE_ROLES_SUCCESS = 'UPDATE_ROLES_SUCCESS';
export const POST_ROLES_SUCCESS = 'POST_ROLES_SUCCESS';
export const CHECK_DELETE_ROLES_SUCCESS = 'CHECK_DELETE_ROLES_SUCCESS';

// ----- ramos -----------------------------------------------------------------------------------
export const REQUEST_FIELD_OF_ACTIVITIES_START = 'REQUEST_FIELD_OF_ACTIVITIES_START';
export const FETCH_FIELD_OF_ACTIVITIES_SUCCESS = 'FETCH_FIELD_OF_ACTIVITIES_SUCCESS';
export const REQUEST_FIELD_OF_ACTIVITIES_FAIL = 'REQUEST_FIELD_OF_ACTIVITIES_FAIL';
export const DELETE_FIELD_OF_ACTIVITIES_SUCCESS = 'DELETE_FIELD_OF_ACTIVITIES_SUCCESS';
export const UPDATE_FIELD_OF_ACTIVITIES_SUCCESS = 'UPDATE_FIELD_OF_ACTIVITIES_SUCCESS';
export const POST_FIELD_OF_ACTIVITIES_SUCCESS = 'POST_FIELD_OF_ACTIVITIES_SUCCESS';
export const CHECK_DELETE_FIELD_OF_ACTIVITIES_SUCCESS = 'CHECK_DELETE_FIELD_OF_ACTIVITIES_SUCCESS';

// ----- empresas ---------------------------------------------------------------------------
export const REQUEST_COMPANIES_START = 'REQUEST_COMPANIES_START';
export const FETCH_COMPANIES_SUCCESS = 'FETCH_COMPANIES_SUCCESS';
export const FETCH_COMPANIES_BY_ID_SUCCESS = 'FETCH_COMPANIES_BY_ID_SUCCESS';
export const REQUEST_COMPANIES_FAIL = 'REQUEST_COMPANIES_FAIL';
export const DELETE_COMPANIES_SUCCESS = 'DELETE_COMPANIES_SUCCESS';
export const UPDATE_COMPANIES_SUCCESS = 'UPDATE_COMPANIES_SUCCESS';
export const POST_COMPANIES_SUCCESS = 'POST_COMPANIES_SUCCESS';
export const FETCH_COMPANIES_INFINITE_SCROLL_SUCCESS = 'FETCH_COMPANIES_INFINITE_SCROLL_SUCCESS';
export const REQUEST_COMPANIES_INFINITE_SCROLL_START = 'REQUEST_COMPANIES_INFINITE_SCROLL_START';
export const CHECK_DELETE_COMPANIES_SUCCESS = 'CHECK_DELETE_COMPANIES_SUCCESS'
export const SET_COMPANIES_FILTER = '[COMPANIES] SET_COMPANIES_FILTER';


// ----- SERVICE TYPES -----------------------------------------------------------------------------------
export const REQUEST_SERVICE_TYPES_START = 'REQUEST_SERVICE_TYPES_START';
export const FETCH_SERVICE_TYPES_SUCCESS = 'FETCH_SERVICE_TYPES_SUCCESS';
export const REQUEST_SERVICE_TYPES_FAIL = 'REQUEST_SERVICE_TYPES_FAIL';
export const DELETE_SERVICE_TYPES_SUCCESS = 'DELETE_SERVICE_TYPES_SUCCESS';
export const UPDATE_SERVICE_TYPES_SUCCESS = 'UPDATE_SERVICE_TYPES_SUCCESS';
export const POST_SERVICE_TYPES_SUCCESS = 'POST_SERVICE_TYPES_SUCCESS';
export const CHECK_DELETE_SERVICE_TYPES_SUCCESS = 'CHECK_DELETE_SERVICE_TYPES_SUCCESS';
export const SET_SERVICE_TYPE_FILTER = 'SET_SERVICE_TYPE_FILTER';

// ----- PLACES -----------------------------------------------------------------------------------
export const REQUEST_PLACES_START = 'REQUEST_PLACES_START';
export const FETCH_PLACES_SUCCESS = 'FETCH_PLACES_SUCCESS';
export const FETCH_PLACES_LEAFS_SUCCESS = 'FETCH_PLACES_LEAFS_SUCCESS';
export const FETCH_PLACES_ROOTS_SUCCESS = 'FETCH_PLACES_ROOTS_SUCCESS';
export const REQUEST_PLACES_FAIL = 'REQUEST_PLACES_FAIL';
export const DELETE_PLACES_SUCCESS = 'DELETE_PLACES_SUCCESS';
export const UPDATE_PLACES_SUCCESS = 'UPDATE_PLACES_SUCCESS';
export const POST_PLACES_SUCCESS = 'POST_PLACES_SUCCESS';
export const CHECK_DELETE_PLACES_SUCCESS = 'CHECK_DELETE_PLACES_SUCCESS';
export const TOOGLE_PLACES = 'TOOGLE_PLACES';
export const FETCH_PLACES_BY_ID_SUCCESS = 'FETCH_PLACES_BY_ID_SUCCESS';
export const SEARCH_PLACES = 'SEARCH_PLACES';
export const SEARCH_TEXT_PLACES = 'SEARCH_TEXT_PLACES';
export const SET_COPY_PLACE = 'SET_COPY_PLACE';
export const CLEAR_COPY_PLACE = 'CLEAR_COPY_PLACE';
export const COPY_PASTE_PLACE_SUCCESS = 'COPY_PASTE_PLACE_SUCCESS'
export const SET_MAP_CONFIG = 'SET_MAP_CONFIG'

// ----- FREQUENCY ---------------------------------------------------------------------------
export const REQUEST_FREQUENCY_START = 'REQUEST_FREQUENCY_START';
export const FETCH_FREQUENCY_SUCCESS = 'FETCH_FREQUENCY_SUCCESS';
export const FETCH_FREQUENCY_BY_ID_SUCCESS = 'FETCH_FREQUENCY_BY_ID_SUCCESS';
export const REQUEST_FREQUENCY_FAIL = 'REQUEST_FREQUENCY_FAIL';
export const DELETE_FREQUENCY_SUCCESS = 'DELETE_FREQUENCY_SUCCESS';
export const UPDATE_FREQUENCY_SUCCESS = 'UPDATE_FREQUENCY_SUCCESS';
export const POST_FREQUENCY_SUCCESS = 'POST_FREQUENCY_SUCCESS';
export const CHECK_DELETE_FREQUENCY_SUCCESS = 'CHECK_DELETE_FREQUENCY_SUCCESS';
export const SET_FREQUENCIES_FILTER = '[FREQUENCY] SET_FREQUENCIES_FILTER';

// ----- STATUS VERIFICATION ITEMS -----------------------------------------------------------------------------------
export const REQUEST_STATUS_VERIFICATION_ITEMS_START = 'REQUEST_STATUS_VERIFICATION_ITEMS_START';
export const FETCH_STATUS_VERIFICATION_ITEMS_SUCCESS = 'FETCH_STATUS_VERIFICATION_ITEMS_SUCCESS';
export const REQUEST_STATUS_VERIFICATION_ITEMS_FAIL = 'REQUEST_STATUS_VERIFICATION_ITEMS_FAIL';
export const DELETE_STATUS_VERIFICATION_ITEMS_SUCCESS = 'DELETE_STATUS_VERIFICATION_ITEMS_SUCCESS';
export const UPDATE_STATUS_VERIFICATION_ITEMS_SUCCESS = 'UPDATE_STATUS_VERIFICATION_ITEMS_SUCCESS';
export const POST_STATUS_VERIFICATION_ITEMS_SUCCESS = 'POST_STATUS_VERIFICATION_ITEMS_SUCCESS';
export const CHECK_DELETE_STATUS_VERIFICATION_ITEMS_SUCCESS = 'CHECK_DELETE_STATUS_VERIFICATION_ITEMS_SUCCESS';

// ----- GROUPS ---------------------------------------------------------------------------
export const REQUEST_GROUPS_START = 'REQUEST_GROUPS_START';
export const FETCH_GROUPS_SUCCESS = 'FETCH_GROUPS_SUCCESS';
export const FETCH_GROUPS_BY_ID_SUCCESS = 'FETCH_GROUPS_BY_ID_SUCCESS';
export const REQUEST_GROUPS_FAIL = 'REQUEST_GROUPS_FAIL';
export const DELETE_GROUPS_SUCCESS = 'DELETE_GROUPS_SUCCESS';
export const UPDATE_GROUPS_SUCCESS = 'UPDATE_GROUPS_SUCCESS';
export const POST_GROUPS_SUCCESS = 'POST_GROUPS_SUCCESS';
export const CHECK_DELETE_GROUPS_SUCCESS = 'CHECK_DELETE_GROUPS_SUCCESS';
export const SET_GROUPS_FILTER = '[GROUPS] SET_GROUPS_FILTER';

// ----- EQUIPMENT MODELS ---------------------------------------------------------------------------
export const REQUEST_EQUIPMENT_MODELS_START = 'REQUEST_EQUIPMENT_MODELS_START';
export const SET_EQUIPMENT_MODEL_FILTER = '[EQUIPMENT MODEL] SET_EQUIPMENT_MODEL_NAME'
export const FETCH_EQUIPMENT_MODELS_SUCCESS = 'FETCH_EQUIPMENT_MODELS_SUCCESS';
export const FETCH_EQUIPMENT_MODELS_BY_ID_SUCCESS = 'FETCH_EQUIPMENT_MODELS_BY_ID_SUCCESS';
export const REQUEST_EQUIPMENT_MODELS_FAIL = 'REQUEST_EQUIPMENT_MODELS_FAIL';
export const DELETE_EQUIPMENT_MODELS_SUCCESS = 'DELETE_EQUIPMENT_MODELS_SUCCESS';
export const UPDATE_EQUIPMENT_MODELS_SUCCESS = 'UPDATE_EQUIPMENT_MODELS_SUCCESS';
export const POST_EQUIPMENT_MODELS_SUCCESS = 'POST_EQUIPMENT_MODELS_SUCCESS';
export const CHECK_DELETE_EQUIPMENT_MODELS_SUCCESS = 'CHECK_DELETE_EQUIPMENT_MODELS_SUCCESS';
export const REMOVE_SERVICE_EQUIPMENT_MODELS_SUCCESS = 'REMOVE_SERVICE_EQUIPMENT_MODELS_SUCCESS';
export const ADD_SERVICE_EQUIPMENT_MODELS_SUCCESS = 'ADD_SERVICE_EQUIPMENT_MODELS_SUCCESS';
export const UPDATE_EQUIPMENT_SERVICE_IN_MODEL = 'UPDATE_EQUIPMENT_SERVICE_IN_MODEL'
export const REQUEST_CLONE_EQUIPMENT_MODELS_START = 'REQUEST_CLONE_EQUIPMENT_MODELS_START'
export const REQUEST_CLONE_EQUIPMENT_MODELS_SUCCESS = 'REQUEST_CLONE_EQUIPMENT_MODELS_SUCCESS'
export const REQUEST_CLONE_EQUIPMENT_MODELS_FAIL = 'REQUEST_CLONE_EQUIPMENT_MODELS_FAIL'
export const REQUEST_CLONE_EQUIPMENT_MODEL_SERVICES_START = 'REQUEST_CLONE_EQUIPMENT_MODEL_SERVICES_START'
export const REQUEST_CLONE_EQUIPMENT_MODEL_SERVICES_SUCCESS = 'REQUEST_CLONE_EQUIPMENT_MODEL_SERVICES_SUCCESS'
export const REQUEST_CLONE_EQUIPMENT_MODEL_SERVICES_FAIL = 'REQUEST_CLONE_EQUIPMENT_MODEL_SERVICES_FAIL'
export const REQUEST_DELETE_EQUIPMENT_SERVICES_CHECKLIST_START = '[EQUIPMENT SERVICES] REQUEST_DELETE_EQUIPMENT_SERVICES_CHECKLIST_START'
export const REQUEST_DELETE_EQUIPMENT_SERVICES_CHECKLIST_SUCCESS = '[EQUIPMENT SERVICES] REQUEST_DELETE_EQUIPMENT_SERVICES_CHECKLIST_SUCCESS'
export const REQUEST_DELETE_EQUIPMENT_SERVICES_CHECKLIST_FAIL = '[EQUIPMENT SERVICES] REQUEST_DELETE_EQUIPMENT_SERVICES_CHECKLIST_FAIL'

export const EQUIPMENT_SERVICES_INACTIVATE_START = 'EQUIPMENT_SERVICES_INACTIVATE_START';
export const EQUIPMENT_SERVICES_INACTIVATE_SUCCESS = 'EQUIPMENT_SERVICES_INACTIVATE_SUCCESS';
export const EQUIPMENT_SERVICES_INACTIVATE_FAIL = 'EQUIPMENT_SERVICES_INACTIVATE_FAIL';

export const EQUIPMENT_SERVICES_ACTIVATE_START = 'EQUIPMENT_SERVICES_ACTIVATE_START';
export const EQUIPMENT_SERVICES_ACTIVATE_SUCCESS = 'EQUIPMENT_SERVICES_ACTIVATE_SUCCESS';
export const EQUIPMENT_SERVICES_ACTIVATE_FAIL = 'EQUIPMENT_SERVICES_ACTIVATE_FAIL';

// ----- EQUIPAMENTOS ---------------------------------------------------------------------------
export const REQUEST_EQUIPMENTS_START = '[EQUIPMENTS] REQUEST_EQUIPMENTS_START';
export const FETCH_EQUIPMENTS_SUCCESS = '[EQUIPMENTS] FETCH_EQUIPMENTS_SUCCESS';
export const FETCH_EQUIPMENTS_BY_PLACE_SUCCESS = '[EQUIPMENTS] FETCH_EQUIPMENTS_BY_PLACE_SUCCESS';
export const FETCH_EQUIPMENTS_BY_ID_SUCCESS = '[EQUIPMENTS] FETCH_EQUIPMENTS_BY_ID_SUCCESS';
export const SET_EQUIPMENTS_MANUFACTURING_DATE = '[EQUIPMENTS] SET_EQUIPMENTS_MANUFACTURING_DATE'
export const REQUEST_EQUIPMENTS_FAIL = '[EQUIPMENTS] REQUEST_EQUIPMENTS_FAIL';
export const DELETE_EQUIPMENTS_SUCCESS = '[EQUIPMENTS] DELETE_EQUIPMENTS_SUCCESS';
export const UPDATE_EQUIPMENTS_SUCCESS = '[EQUIPMENTS] UPDATE_EQUIPMENTS_SUCCESS';
export const EQUIPMENTS_FETCH_TIMELINE_START = 'EQUIPMENTS_FETCH_TIMELINE_START';
export const EQUIPMENTS_FETCH_TIMELINE_SUCCESS = 'EQUIPMENTS_FETCH_TIMELINE_SUCCESS';
export const EQUIPMENTS_FETCH_TIMELINE_FAIL = 'EQUIPMENTS_FETCH_TIMELINE_FAIL';

export const REVERT_DELETED_EQUIPMENT_SUCCESS = '[EQUIPMENTS] REVERT_DELETED_EQUIPMENT_SUCCESS';
export const REVERT_DELETED_EQUIPMENT_START = '[EQUIPMENTS] REVERT_DELETED_EQUIPMENT_START';
export const REVERT_DELETED_EQUIPMENT_FAIL = '[EQUIPMENTS] REVERT_DELETED_EQUIPMENT_FAIL';
export const INACTIVATE_EQUIPMENTS_SUCCESS = '[EQUIPMENTS] INACTIVATE_EQUIPMENTS_SUCCESS';
export const MAINTENANCE_EQUIPMENTS_SUCCESS = '[EQUIPMENTS] MAINTENANCE_EQUIPMENTS_SUCCESS';
export const DELETE_MULTIPLE_EQUIPMENTS_SUCCESS = '[EQUIPMENTS] DELETE_MULTIPLE_EQUIPMENTS_SUCCESS';
export const POST_EQUIPMENTS_SUCCESS = '[EQUIPMENTS] POST_EQUIPMENTS_SUCCESS';
export const CHECK_DELETE_EQUIPMENTS_SUCCESS = '[EQUIPMENTS] CHECK_DELETE_EQUIPMENTS_SUCCESS';
export const FETCH_EQUIPMENTS_BY_PLACE_INFINITE_SCROLL_SUCCESS = '[EQUIPMENTS] FETCH_EQUIPMENTS_BY_PLACE_INFINITE_SCROLL_SUCCESS';
export const REQUEST_EQUIPMENTS_INFINITE_SCROLL_START = '[EQUIPMENTS] REQUEST_EQUIPMENTS_INFINITE_SCROLL_START';
export const REQUEST_EQUIPMENTS_BY_PLACE_INFINITE_SCROLL_START = '[EQUIPMENTS] REQUEST_EQUIPMENTS_BY_PLACE_INFINITE_SCROLL_START';
export const SET_SEARCH_TEXT_EQUIPMENT_BY_PLACE = '[EQUIPMENTS] SET_SEARCH_TEXT_EQUIPMENT_BY_PLACE';
export const SET_DATA_CHANGED_FORCE_RELOAD = '[EQUIPMENTS] SET_DATA_CHANGED_FORCE_RELOAD';
export const SET_EQUIPMENTS_FILTER = '[EQUIPMENTS] SET_EQUIPMENTS_FILTER';
export const FILTER_EQUIPMENT_STATUS = '[EQUIPMENTS] FILTER_EQUIPMENT_STATUS';
export const FILTER_EQUIPMENT_SITES = '[EQUIPMENTS] FILTER_EQUIPMENT_SITES';
export const FILTER_EQUIPMENT_SITES_REMOVE = '[EQUIPMENTS] FILTER_EQUIPMENT_SITES_REMOVE';
export const FILTER_EQUIPMENT_GROUPS = '[EQUIPMENTS] FILTER_EQUIPMENT_GROUPS';
export const FILTER_EQUIPMENT_GROUPS_REMOVE = '[EQUIPMENTS] FILTER_EQUIPMENT_GROUPS_REMOVE';
export const FILTER_EQUIPMENT_AREAS = '[EQUIPMENTS] FILTER_EQUIPMENT_AREAS';
export const FILTER_EQUIPMENT_AREAS_REMOVE = '[EQUIPMENTS] FILTER_EQUIPMENT_AREAS_REMOVE';
export const FILTER_EQUIPMENT_DELETEDEQUIPMENTS = '[EQUIPMENTS] FILTER_EQUIPMENT_DELETEDEQUIPMENTS';
export const FILTER_EQUIPMENT_DELETEDEQUIPMENTS_REMOVE = '[EQUIPMENTS] FILTER_EQUIPMENT_DELETEDEQUIPMENTS_REMOVE';
export const FILTER_EQUIPMENT_COMPANIES = '[EQUIPMENTS] FILTER_EQUIPMENT_COMPANIES';
export const FILTER_EQUIPMENT_COMPANIES_REMOVE = '[EQUIPMENTS] FILTER_EQUIPMENT_COMPANIES_REMOVE';
export const FILTER_EQUIPMENT_PLACES = '[EQUIPMENTS] FILTER_EQUIPMENT_PLACES';
export const FILTER_EQUIPMENT_PLACES_REMOVE = '[EQUIPMENTS] FILTER_EQUIPMENT_PLACES_REMOVE';
export const FILTER_EQUIPMENT_MODELS = '[EQUIPMENTS] FILTER_EQUIPMENT_MODELS';
export const FILTER_EQUIPMENT_MODELS_REMOVE = '[EQUIPMENTS] FILTER_EQUIPMENT_MODELS_REMOVE';
export const FILTER_EQUIPMENT_CLEAR = '[EQUIPMENTS] FILTER_EQUIPMENT_CLEAR';
export const SET_EQUIPMENTS_BY_PLACE_FILTER = '[EQUIPMENTS] SET_EQUIPMENTS_BY_PLACE_FILTER';
export const FILTER_EQUIPMENT_BY_PLACE_STATUS = '[EQUIPMENTS] FILTER_EQUIPMENT_BY_PLACE_STATUS';
export const FILTER_EQUIPMENT_BY_PLACE_SITES = '[EQUIPMENTS] FILTER_EQUIPMENT_BY_PLACE_SITES';
export const FILTER_EQUIPMENT_BY_PLACE_SITES_REMOVE = '[EQUIPMENTS] FILTER_EQUIPMENT_BY_PLACE_SITES_REMOVE';
export const FILTER_EQUIPMENT_BY_PLACE_GROUPS = '[EQUIPMENTS] FILTER_EQUIPMENT_BY_PLACE_GROUPS';
export const FILTER_EQUIPMENT_BY_PLACE_GROUPS_REMOVE = '[EQUIPMENTS] FILTER_EQUIPMENT_BY_PLACE_GROUPS_REMOVE';
export const FILTER_EQUIPMENT_BY_PLACE_AREAS = '[EQUIPMENTS] FILTER_EQUIPMENT_BY_PLACE_AREAS';
export const FILTER_EQUIPMENT_BY_PLACE_AREAS_REMOVE = '[EQUIPMENTS] FILTER_EQUIPMENT_BY_PLACE_AREAS_REMOVE';
export const FILTER_EQUIPMENT_BY_PLACE_COMPANIES = '[EQUIPMENTS] FILTER_EQUIPMENT_BY_PLACE_COMPANIES';
export const FILTER_EQUIPMENT_BY_PLACE_COMPANIES_REMOVE = '[EQUIPMENTS] FILTER_EQUIPMENT_BY_PLACE_COMPANIES_REMOVE';
export const FILTER_EQUIPMENT_BY_PLACE_MODELS = '[EQUIPMENTS] FILTER_EQUIPMENT_BY_PLACE_MODELS';
export const FILTER_EQUIPMENT_BY_PLACE_MODELS_REMOVE = '[EQUIPMENTS] FILTER_EQUIPMENT_BY_PLACE_MODELS_REMOVE';
export const FILTER_EQUIPMENT_BY_PLACE_CLEAR = '[EQUIPMENTS] FILTER_EQUIPMENT_BY_PLACE_CLEAR';
export const SET_EXPIRATION_DATE_SERVICE_EQUIPMENTS_CREATE_FORM = '[EQUIPMENTS] SET_EXPIRATION_DATE_SERVICE_EQUIPMENTS_CREATE_FORM'
export const CLEAR_EQUIPMENTS_EQUIPMENT_MODELS_BY_ID = '[EQUIPMENTS] CLEAR_EQUIPMENTS_EQUIPMENT_MODELS_BY_ID'

export const EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_START = '[EQUIPMENTS] EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_START';
export const EQUIPMENTS_FETCH_EQUIPMENT_MODELS_SUCCESS = '[EQUIPMENTS] EQUIPMENTS_FETCH_EQUIPMENT_MODELS_SUCCESS';
export const EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_FAIL = '[EQUIPMENTS] EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_FAIL';
export const EQUIPMENTS_FETCH_EQUIPMENT_MODELS_BY_ID_SUCCESS = '[EQUIPMENTS] EQUIPMENTS_FETCH_EQUIPMENT_MODELS_BY_ID_SUCCESS';

export const EQUIPMENTS_REQUEST_GROUPS_START = '[EQUIPMENTS] EQUIPMENTS_REQUEST_GROUPS_START';
export const EQUIPMENTS_FETCH_GROUPS_SUCCESS = '[EQUIPMENTS] EQUIPMENTS_FETCH_GROUPS_SUCCESS';
export const EQUIPMENTS_REQUEST_GROUPS_FAIL = '[EQUIPMENTS] EQUIPMENTS_REQUEST_GROUPS_FAIL';

export const EQUIPMENTS_REQUEST_AREAS_START = '[EQUIPMENTS] EQUIPMENTS_REQUEST_AREAS_START';
export const EQUIPMENTS_FETCH_AREAS_SUCCESS = '[EQUIPMENTS] EQUIPMENTS_FETCH_AREAS_SUCCESS';
export const EQUIPMENTS_REQUEST_AREAS_FAIL = '[EQUIPMENTS] EQUIPMENTS_REQUEST_AREAS_FAIL';

export const EQUIPMENTS_REQUEST_COMPANIES_START = '[EQUIPMENTS] EQUIPMENTS_REQUEST_COMPANIES_START';
export const EQUIPMENTS_FETCH_COMPANIES_SUCCESS = '[EQUIPMENTS] EQUIPMENTS_FETCH_COMPANIES_SUCCESS';
export const EQUIPMENTS_REQUEST_COMPANIES_FAIL = '[EQUIPMENTS] EQUIPMENTS_REQUEST_COMPANIES_FAIL';

export const EQUIPMENTS_FETCH_PLACES_LEAFS_SUCCESS = '[EQUIPMENTS] EQUIPMENTS_FETCH_PLACES_LEAFS_SUCCESS';
export const EQUIPMENTS_REQUEST_PLACES_FAIL = '[EQUIPMENTS] EQUIPMENTS_REQUEST_PLACES_FAIL';
export const EQUIPMENTS_REQUEST_PLACES_START = '[EQUIPMENTS] EQUIPMENTS_REQUEST_PLACES_START';
export const EQUIPMENTS_FETCH_PLACES_BY_ID_SUCCESS = '[EQUIPMENTS] EQUIPMENTS_FETCH_PLACES_BY_ID_SUCCESS';
export const EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_BY_ID_FAIL = '[EQUIPMENTS] EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_BY_ID_FAIL';
export const EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_BY_ID_START = '[EQUIPMENTS] EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_BY_ID_START';

export const FETCH_ACTIONS_BY_EQUIPMENT_START = '[EQUIPMENTS] FETCH_ACTIONS_BY_EQUIPMENT_START'
export const FETCH_MORE_ACTIONS_BY_EQUIPMENT_START = '[EQUIPMENTS] FETCH_MORE_ACTIONS_BY_EQUIPMENT_START'
export const FETCH_ACTIONS_BY_EQUIPMENT_SUCCESS = '[EQUIPMENTS] FETCH_ACTIONS_BY_EQUIPMENT_SUCCESS'
export const FETCH_MORE_ACTIONS_BY_EQUIPMENT_SUCCESS = '[EQUIPMENTS] FETCH_MORE_ACTIONS_BY_EQUIPMENT_SUCCESS'
export const FETCH_ACTIONS_BY_EQUIPMENT_FAIL = '[EQUIPMENTS] FETCH_ACTIONS_BY_EQUIPMENT_FAIL'
export const FETCH_MORE_ACTIONS_BY_EQUIPMENT_FAIL = '[EQUIPMENTS] FETCH_MORE_ACTIONS_BY_EQUIPMENT_FAIL'

export const FETCH_EQUIPMENT_BY_ID_SUCCESS = 'FETCH_EQUIPMENT_BY_ID_SUCCESS';
export const REQUEST_EQUIPMENT_START = 'REQUEST_EQUIPMENT_START';
export const REQUEST_EQUIPMENT_FAIL = 'REQUEST_EQUIPMENT_FAIL';

export const FETCH_EQUIPMENT_ATTACHMENTFILE_BY_ID_SUCCESS = 'FETCH_EQUIPMENT_ATTACHMENTFILE_BY_ID_SUCCESS';
export const REQUEST_EQUIPMENT_ATTACHMENTFILE_DOCUMENT_START = 'REQUEST_EQUIPMENT_ATTACHMENTFILE_DOCUMENT_START';
export const REQUEST_EQUIPMENT_ATTACHMENTFILE_DOCUMENT_FAIL = 'REQUEST_EQUIPMENT_ATTACHMENTFILE_DOCUMENT_FAIL';

export const EQUIPMENTS_FETCH_SERVICES_REPLICATED_ZIP_START = 'EQUIPMENTS_FETCH_SERVICES_REPLICATED_ZIP_START';
export const EQUIPMENTS_FETCH_SERVICES_REPLICATED_ZIP_SUCCESS = 'EQUIPMENTS_FETCH_SERVICES_REPLICATED_ZIP_SUCCESS';
export const EQUIPMENTS_FETCH_SERVICES_REPLICATED_ZIP_FAIL = 'EQUIPMENTS_FETCH_SERVICES_REPLICATED_ZIP_FAIL';

export const EQUIPMENTS_FETCH_SERVICES_SIMPLIFIED_START = 'EQUIPMENTS_FETCH_SERVICES_SIMPLIFIED_START';
export const EQUIPMENTS_FETCH_SERVICES_SIMPLIFIED_SUCCESS = 'EQUIPMENTS_FETCH_SERVICES_SIMPLIFIED_SUCCESS';
export const EQUIPMENTS_FETCH_SERVICES_SIMPLIFIED_FAIL = 'EQUIPMENTS_FETCH_SERVICES_SIMPLIFIED_FAIL';

export const EQUIPMENTS_FETCH_SERVICE_DRAFTS_START = 'EQUIPMENTS_FETCH_SERVICE_DRAFTS_START';
export const EQUIPMENTS_FETCH_SERVICE_DRAFTS_SUCCESS = 'EQUIPMENTS_FETCH_SERVICE_DRAFTS_SUCCESS';
export const EQUIPMENTS_FETCH_SERVICE_DRAFTS_FAIL = 'EQUIPMENTS_FETCH_SERVICE_DRAFTS_FAIL';
export const EQUIPMENTS_DELETE_SERVICE_DRAFT_START = 'EQUIPMENTS_DELETE_SERVICE_DRAFT_START';
export const EQUIPMENTS_DELETE_SERVICE_DRAFT_SUCCESS = 'EQUIPMENTS_DELETE_SERVICE_DRAFT_SUCCESS';
export const EQUIPMENTS_DELETE_SERVICE_DRAFT_FAIL = 'EQUIPMENTS_DELETE_SERVICE_DRAFT_FAIL';


// ----- SERVICOS ---------------------------------------------------------------------------
export const REQUEST_SERVICES_START = 'REQUEST_SERVICES_START';
export const FETCH_SERVICES_SUCCESS = 'FETCH_SERVICES_SUCCESS';
export const FETCH_SERVICES_BY_ID_SUCCESS = 'FETCH_SERVICES_BY_ID_SUCCESS';
export const REQUEST_SERVICES_FAIL = 'REQUEST_SERVICES_FAIL';
export const DELETE_SERVICES_SUCCESS = 'DELETE_SERVICES_SUCCESS';
export const UPDATE_SERVICES_SUCCESS = 'UPDATE_SERVICES_SUCCESS';
export const POST_SERVICES_SUCCESS = 'POST_SERVICES_SUCCESS';
export const CHECK_DELETE_SERVICES_SUCCESS = 'CHECK_DELETE_SERVICES_SUCCESS';
export const SET_SERVICES_FILTER = 'SET_SERVICES_FILTER';
export const SET_SERVICES_SELECTED = 'SET_SERVICES_SELECTED';
export const CLEAR_SERVICES_SELECTED = 'CLEAR_SERVICES_SELECTED';
export const FETCH_SERVICES_BY_EQUIPMENT_SUCCESS = 'FETCH_SERVICES_BY_EQUIPMENT_SUCCESS';
export const FETCH_MORE_SERVICES_BY_EQUIPMENT_START = 'FETCH_MORE_SERVICES_BY_EQUIPMENT_START';
export const FETCH_MORE_SERVICES_BY_EQUIPMENT_SUCCESS = 'FETCH_MORE_SERVICES_BY_EQUIPMENT_SUCCESS';
export const FETCH_MORE_SERVICES_BY_EQUIPMENT_FAIL = 'FETCH_MORE_SERVICES_BY_EQUIPMENT_FAIL';
export const FILTER_SERVICE_SITES = 'FILTER_SERVICE_SITES';
export const FILTER_SERVICE_SITES_REMOVE = 'FILTER_SERVICE_SITES_REMOVE';
export const FILTER_SERVICE_COMPANIES = 'FILTER_SERVICE_COMPANIES';
export const FILTER_SERVICE_COMPANIES_REMOVE = 'FILTER_SERVICE_COMPANIES_REMOVE';
export const FILTER_SERVICE_SERVICE_TYPES = 'FILTER_SERVICE_SERVICE_TYPES';
export const FILTER_SERVICE_SERVICE_TYPES_REMOVE = 'FILTER_SERVICE_SERVICE_TYPES_REMOVE';
export const FILTER_SERVICE_FREQUENCIES = 'FILTER_SERVICE_FREQUENCIES';
export const FILTER_SERVICE_FREQUENCIES_REMOVE = 'FILTER_SERVICE_FREQUENCIES_REMOVE';
export const FILTER_SERVICE_USERS = 'FILTER_SERVICE_USERS';
export const FILTER_SERVICE_USERS_REMOVE = 'FILTER_SERVICE_USERS_REMOVE';
export const FILTER_SERVICE_PLACES = 'FILTER_SERVICE_PLACES';
export const FILTER_SERVICE_PLACES_REMOVE = 'FILTER_SERVICE_PLACES_REMOVE';
export const FILTER_SERVICE_AREAS = 'FILTER_SERVICE_AREAS';
export const FILTER_SERVICE_AREAS_REMOVE = 'FILTER_SERVICE_AREAS_REMOVE';
export const FILTER_SERVICE_MODELS = 'FILTER_SERVICE_MODELS';
export const FILTER_SERVICE_MODELS_REMOVE = 'FILTER_SERVICE_MODELS_REMOVE';
export const FILTER_SERVICE_GROUPS = 'FILTER_SERVICE_GROUPS';
export const FILTER_SERVICE_GROUPS_REMOVE = 'FILTER_SERVICE_GROUPS_REMOVE';
export const FILTER_SERVICE_START_DATE = 'FILTER_SERVICE_START_DATE';
export const FILTER_SERVICE_START_DATE_REMOVE = 'FILTER_SERVICE_START_DATE_REMOVE';
export const FILTER_SERVICE_END_DATE = 'FILTER_SERVICE_END_DATE';
export const FILTER_SERVICE_END_DATE_REMOVE = 'FILTER_SERVICE_END_DATE_REMOVE';
export const FILTER_SERVICE_CLEAR = 'FILTER_SERVICE_CLEAR';
export const SERVICES_TABLE_FETCH_EQUIPMENTS_START = 'SERVICES_TABLE_FETCH_EQUIPMENTS_START';
export const SERVICES_TABLE_FETCH_EQUIPMENTS_SUCCESS = 'SERVICES_TABLE_FETCH_EQUIPMENTS_SUCCESS';
export const SERVICES_TABLE_FETCH_EQUIPMENTS_FAIL = 'SERVICES_TABLE_FETCH_EQUIPMENTS_FAIL';
export const FILTER_SERVICE_EQUIPMENT = 'FILTER_SERVICE_EQUIPMENT';
export const FILTER_SERVICE_SOURCES = 'FILTER_SERVICE_SOURCES';
export const FILTER_SERVICE_DONE_IN_DELAY = 'FILTER_SERVICE_DONE_IN_DELAY';


// ----- INSPECOES ---------------------------------------------------------------------------
export const REQUEST_EQUIPMENT_SERVICES_START = 'REQUEST_EQUIPMENT_SERVICES_START';
export const REQUEST_SELECTED_EQUIPMENT_MASS_SERVICES_START = 'REQUEST_SELECTED_EQUIPMENT_MASS_SERVICES_START';
export const FETCH_EQUIPMENT_SERVICES_SUCCESS = 'FETCH_EQUIPMENT_SERVICES_SUCCESS';
export const FETCH_SELECTED_EQUIPMENT_MASS_SERVICES_SUCCESS = 'FETCH_SELECTED_EQUIPMENT_MASS_SERVICES_SUCCESS';
export const FETCH_EQUIPMENT_SERVICES_BY_ID_SUCCESS = 'FETCH_EQUIPMENT_SERVICES_BY_ID_SUCCESS';
export const REQUEST_EQUIPMENT_SERVICES_FAIL = 'REQUEST_EQUIPMENT_SERVICES_FAIL';
export const REQUEST_SELECTED_EQUIPMENT_MASS_SERVICES_FAIL = 'REQUEST_SELECTED_EQUIPMENT_MASS_SERVICES_FAIL';
export const DELETE_EQUIPMENT_SERVICES_SUCCESS = 'DELETE_EQUIPMENT_SERVICES_SUCCESS';
export const UPDATE_EQUIPMENT_SERVICES_SUCCESS = 'UPDATE_EQUIPMENT_SERVICES_SUCCESS';
export const POST_EQUIPMENT_SERVICES_SUCCESS = 'POST_EQUIPMENT_SERVICES_SUCCESS';
export const CHECK_DELETE_EQUIPMENT_SERVICES_SUCCESS = 'CHECK_DELETE_EQUIPMENT_SERVICES_SUCCESS'
export const HARD_DELETE_EQUIPMENT_SERVICES_SUCCESS = 'HARD_DELETE_EQUIPMENT_SERVICES_SUCCESS'
export const POST_MASS_SERVICE_SUCCESS = 'POST_MASS_SERVICE_SUCCESS'
export const REQUEST_MASS_SERVICES_FAIL = 'REQUEST_MASS_SERVICES_FAIL'

// ----- QUESTOES ---------------------------------------------------------------------------
export const REQUEST_QUESTIONS_START = 'REQUEST_QUESTIONS_START';
export const FETCH_QUESTIONS_SUCCESS = 'FETCH_QUESTIONS_SUCCESS';
export const FETCH_QUESTIONS_BY_ID_SUCCESS = 'FETCH_QUESTIONS_BY_ID_SUCCESS';
export const REQUEST_QUESTIONS_FAIL = 'REQUEST_QUESTIONS_FAIL';
export const DELETE_QUESTIONS_SUCCESS = 'DELETE_QUESTIONS_SUCCESS';
export const UPDATE_QUESTIONS_SUCCESS = 'UPDATE_QUESTIONS_SUCCESS';
export const POST_QUESTIONS_SUCCESS = 'POST_QUESTIONS_SUCCESS';
export const CHECK_DELETE_QUESTIONS_SUCCESS = 'CHECK_DELETE_QUESTIONS_SUCCESS'
export const HARD_DELETE_QUESTIONS_SUCCESS = 'HARD_DELETE_QUESTIONS_SUCCESS'

// ----- tenants -----------------------------------------------------------------------------------
export const REQUEST_TENANTS_START = 'REQUEST_TENANTS_START';
export const FETCH_TENANTS_SUCCESS = 'FETCH_TENANTS_SUCCESS';
export const FETCH_TENANTS_BY_ID_SUCCESS = 'FETCH_TENANTS_BY_ID_SUCCESS';
export const REQUEST_TENANTS_FAIL = 'REQUEST_TENANTS_FAIL';
export const DELETE_TENANTS_SUCCESS = 'DELETE_TENANTS_SUCCESS';
export const UPDATE_TENANTS_SUCCESS = 'UPDATE_TENANTS_SUCCESS';
export const POST_TENANTS_SUCCESS = 'POST_TENANTS_SUCCESS';
export const CHECK_DELETE_TENANTS_SUCCESS = 'CHECK_DELETE_TENANTS_SUCCESS';
export const TENANTS_FETCH_EQUIPMENT_MODELS = 'TENANTS_FETCH_EQUIPMENT_MODELS';
export const TENANTS_FETCH_EQUIPMENT_MODELS_START = 'TENANTS_FETCH_EQUIPMENT_MODELS_START';
export const TENANTS_FETCH_EQUIPMENT_MODELS_SUCCESS = 'TENANTS_FETCH_EQUIPMENT_MODELS_SUCCESS';
export const TENANTS_FETCH_EQUIPMENT_MODELS_ERROR = 'TENANTS_FETCH_EQUIPMENT_MODELS_ERROR';
export const TENANTS_FETCH_EQUIPMENT_BY_ID = 'TENANTS_FETCH_EQUIPMENT_BY_ID';
export const TENANTS_FETCH_EQUIPMENT_BY_ID_START = 'TENANTS_FETCH_EQUIPMENT_BY_ID_START';
export const TENANTS_FETCH_EQUIPMENT_BY_ID_SUCCESS = 'TENANTS_FETCH_EQUIPMENT_BY_ID_SUCCESS';
export const TENANTS_FETCH_EQUIPMENT_BY_ID_ERROR = 'TENANTS_FETCH_EQUIPMENT_BY_ID_ERROR';
export const TENANTS_FETCH_SITES_FOR_MODALS_START = 'TENANTS_FETCH_SITES_FOR_MODALS_START';
export const TENANTS_FETCH_SITES_FOR_MODALS_SUCCESS = 'TENANTS_FETCH_SITES_FOR_MODALS_SUCCESS';
export const TENANTS_FETCH_SITES_FOR_MODALS_FAIL = 'TENANTS_FETCH_SITES_FOR_MODALS_START_FAIL';
export const TENANT_CREATE_API_KEY_START = 'TENANT_CREATE_API_KEY_START';
export const TENANT_CREATE_API_KEY_SUCCESS = 'TENANT_CREATE_API_KEY_SUCCESS';
export const TENANT_CREATE_API_KEY_FAIL = 'TENANT_CREATE_API_KEY_FAIL';
export const TENANT_DELETE_API_KEY_START = 'TENANT_DELETE_API_KEY_START';
export const TENANT_DELETE_API_KEY_SUCCESS = 'TENANT_DELETE_API_KEY_SUCCESS';
export const TENANT_DELETE_API_KEY_FAIL = 'TENANT_DELETE_API_KEY_FAIL';
export const TENANT_UPDATE_WEBHOOK_START = 'TENANT_UPDATE_WEBHOOK_START';
export const TENANT_UPDATE_WEBHOOK_SUCCESS = 'TENANT_UPDATE_WEBHOOK_SUCCESS';
export const TENANT_UPDATE_WEBHOOK_FAIL = 'TENANT_UPDATE_WEBHOOK_FAIL';
export const TENANT_GET_WEBHOOK_START = 'TENANT_GET_WEBHOOK_START';
export const TENANT_GET_WEBHOOK_SUCCESS = 'TENANT_GET_WEBHOOK_SUCCESS';
export const TENANT_GET_WEBHOOK_FAIL = 'TENANT_GET_WEBHOOK_FAIL';
export const TENANT_UPDATE_EQUIPMENTS_REGISTRATION_LIMIT_START = 'TENANT_UPDATE_EQUIPMENTS_REGISTRATION_LIMIT_START';
export const TENANT_UPDATE_EQUIPMENTS_REGISTRATION_LIMIT_SUCCESS = 'TENANT_UPDATE_EQUIPMENTS_REGISTRATION_LIMIT_SUCCESS';
export const TENANT_UPDATE_EQUIPMENTS_REGISTRATION_LIMIT_FAIL = 'TENANT_UPDATE_EQUIPMENTS_REGISTRATION_LIMIT_FAIL';
export const TENANT_FETCH_EQUIPMENTS_COUNT_START = 'TENANT_FETCH_EQUIPMENTS_COUNT_START';
export const TENANT_FETCH_EQUIPMENTS_COUNT_SUCCESS = 'TENANT_FETCH_EQUIPMENTS_COUNT_SUCCESS';
export const TENANT_FETCH_EQUIPMENTS_COUNT_FAIL = 'TENANT_FETCH_EQUIPMENTS_COUNT_FAIL';
export const TOGGLE_EQUIPMENTS_LIMIT_MODAL = 'TOGGLE_EQUIPMENTS_LIMIT_MODAL';
export const TENANTS_FETCH_GAP_USERS_FOR_OPTIONS_START = 'TENANTS_FETCH_GAP_USERS_FOR_OPTIONS_START';
export const TENANTS_FETCH_GAP_USERS_FOR_OPTIONS_SUCCESS = 'TENANTS_FETCH_GAP_USERS_FOR_OPTIONS_SUCCESS';
export const TENANTS_FETCH_GAP_USERS_FOR_OPTIONS_FAIL = 'TENANTS_FETCH_GAP_USERS_FOR_OPTIONS_START_FAIL';
export const TENANT_NOTIFY_ACCOUNTABLES_START = 'TENANT_NOTIFY_ACCOUNTABLES_START';
export const TENANT_NOTIFY_ACCOUNTABLES_SUCCESS = 'TENANT_NOTIFY_ACCOUNTABLES_SUCCESS';
export const TENANT_NOTIFY_ACCOUNTABLES_FAIL = 'TENANT_FETCH_GAP_USERS_FOR_OPTIONS_START_FAIL';

// ----- Calendars -----------------------------------------------------------------------------------
export const FETCH_CALENDARS_SUCCESS = 'FETCH_CALENDARS_SUCCESS';
export const REQUEST_CALENDARS_FAIL = 'REQUEST_CALENDARS_FAIL';
export const REQUEST_CALENDARS_START = 'REQUEST_CALENDARS_START';
export const MODAL_CALENDARS_OPEN = 'MODAL_CALENDARS_OPEN';
export const MODAL_CALENDARS_CLOSE = 'MODAL_CALENDARS_CLOSE';
export const SET_CALENDARS_DATE = 'SET_CALENDARS_DATE';
export const CLEAR_CALENDARS_STATE = 'CLEAR_CALENDARS_STATE';
// filter
export const FILTER_CALENDAR_STATUS = '[CALENDARS] FILTER_CALENDAR_STATUS';
export const FILTER_CALENDAR_STATUS_REMOVE = '[CALENDARS] FILTER_CALENDAR_STATUS_REMOVE';
export const FILTER_CALENDAR_USERS = '[CALENDARS] FILTER_CALENDAR_USERS';
export const FILTER_CALENDAR_USERS_REMOVE = '[CALENDARS] FILTER_CALENDAR_USERS_REMOVE';
export const FILTER_CALENDAR_USERS_MAINTENANCES = '[CALENDARS] FILTER_CALENDAR_USERS_MAINTENANCES';
export const FILTER_CALENDAR_USERS_MAINTENANCES_REMOVE = '[CALENDARS] FILTER_CALENDAR_USERS_MAINTENANCES_REMOVE';
export const FILTER_CALENDAR_MODELS = '[CALENDARS] FILTER_CALENDAR_MODELS';
export const FILTER_CALENDAR_MODELS_REMOVE = '[CALENDARS] FILTER_CALENDAR_MODELS_REMOVE';
export const FILTER_CALENDAR_GROUPS = '[CALENDARS] FILTER_CALENDAR_GROUPS';
export const FILTER_CALENDAR_GROUPS_REMOVE = '[CALENDARS] FILTER_CALENDAR_GROUPS_REMOVE';
export const FILTER_CALENDAR_PLACES = '[CALENDARS] FILTER_CALENDAR_PLACES';
export const FILTER_CALENDAR_PLACES_REMOVE = '[CALENDARS] FILTER_CALENDAR_PLACES_REMOVE';
export const FILTER_CALENDAR_SERVICE_TYPES = 'FILTER_CALENDAR_SERVICE_TYPES';
export const FILTER_CALENDAR_SERVICE_TYPES_REMOVE = 'FILTER_CALENDAR_SERVICE_TYPES_REMOVE';
export const FILTER_CALENDAR_FREQUENCIES = 'FILTER_CALENDAR_FREQUENCIES';
export const FILTER_CALENDAR_FREQUENCIES_REMOVE = 'FILTER_CALENDAR_FREQUENCIES_REMOVE';
export const FILTER_CALENDAR_MODULES = '[CALENDARS] FILTER_CALENDAR_MODULES';
export const FILTER_CALENDAR_MODULES_REMOVE = '[CALENDARS] FILTER_CALENDAR_MODULES_REMOVE';
export const FILTER_CALENDAR_AREAS = '[CALENDARS] FILTER_CALENDAR_AREAS';
export const FILTER_CALENDAR_AREAS_REMOVE = '[CALENDARS] FILTER_CALENDAR_AREAS_REMOVE';
export const FILTER_CALENDAR_COMPANIES = '[CALENDARS] FILTER_CALENDAR_COMPANIES';
export const FILTER_CALENDAR_COMPANIES_REMOVE = '[CALENDARS] FILTER_CALENDAR_COMPANIES_REMOVE';
export const FILTER_CALENDAR_CLEAR = '[CALENDARS] FILTER_CALENDAR_CLEAR';
export const FILTER_CALENDAR_STATUS_MAINTENANCES = '[CALENDARS] FILTER_CALENDAR_STATUS_MAINTENANCES';
export const FILTER_CALENDAR_STATUS_MAINTENANCES_REMOVE = '[CALENDARS] FILTER_CALENDAR_STATUS_MAINTENANCES_REMOVE';

//Event Modal
export const CALENDAR_FETCH_COMPLETED_ACTIONS_BYDAY_START = 'CALENDAR_FETCH_COMPLETED_ACTIONS_BYDAY_START';
export const CALENDAR_FETCH_COMPLETED_ACTIONS_BYDAY_SUCCESS = 'CALENDAR_FETCH_COMPLETED_ACTIONS_BYDAY_SUCCESS';
export const CALENDAR_FETCH_MORE_COMPLETED_ACTIONS_BYDAY_SUCCESS = 'CALENDAR_FETCH_MORE_COMPLETED_ACTIONS_BYDAY_SUCCESS';
export const CALENDAR_FETCH_COMPLETED_ACTIONS_BYDAY_FAIL = 'CALENDAR_FETCH_COMPLETED_ACTIONS_BYDAY_FAIL';

export const CALENDAR_FETCH_INPROGRESS_ACTIONS_BYDAY_START = 'CALENDAR_FETCH_INPROGRESS_ACTIONS_BYDAY_START';
export const CALENDAR_FETCH_INPROGRESS_ACTIONS_BYDAY_SUCCESS = 'CALENDAR_FETCH_INPROGRESS_ACTIONS_BYDAY_SUCCESS';
export const CALENDAR_FETCH_MORE_INPROGRESS_ACTIONS_BYDAY_SUCCESS = 'CALENDAR_FETCH_MORE_INPROGRESS_ACTIONS_BYDAY_SUCCESS';
export const CALENDAR_FETCH_INPROGRESS_ACTIONS_BYDAY_FAIL = 'CALENDAR_FETCH_INPROGRESS_ACTIONS_BYDAY_FAIL';

export const CALENDAR_FETCH_COMPLETED_SERVICES_BYDAY_START = 'CALENDAR_FETCH_COMPLETED_SERVICES_BYDAY_START';
export const CALENDAR_FETCH_COMPLETED_SERVICES_BYDAY_SUCCESS = 'CALENDAR_FETCH_COMPLETED_SERVICES_BYDAY_SUCCESS';
export const CALENDAR_FETCH_MORE_COMPLETED_SERVICES_BYDAY_SUCCESS = 'CALENDAR_FETCH_MORE_COMPLETED_SERVICES_BYDAY_SUCCESS';
export const CALENDAR_FETCH_COMPLETED_SERVICES_BYDAY_FAIL = 'CALENDAR_FETCH_COMPLETED_SERVICES_BYDAY_FAIL';

export const CALENDAR_FETCH_INPROGRESS_SERVICES_BYDAY_START = 'CALENDAR_FETCH_INPROGRESS_SERVICES_BYDAY_START';
export const CALENDAR_FETCH_INPROGRESS_SERVICES_BYDAY_SUCCESS = 'CALENDAR_FETCH_INPROGRESS_SERVICES_BYDAY_SUCCESS';
export const CALENDAR_FETCH_MORE_INPROGRESS_SERVICES_BYDAY_SUCCESS = 'CALENDAR_FETCH_MORE_INPROGRESS_SERVICES_BYDAY_SUCCESS';
export const CALENDAR_FETCH_INPROGRESS_SERVICES_BYDAY_FAIL = 'CALENDAR_FETCH_INPROGRESS_SERVICES_BYDAY_FAIL';

export const CALENDAR_FETCH_MAINTENANCES_BYDAY_START = 'CALENDAR_FETCH_MAINTENANCES_BYDAY_START';
export const CALENDAR_FETCH_MAINTENANCES_BYDAY_SUCCESS = 'CALENDAR_FETCH_MAINTENANCES_BYDAY_SUCCESS';
export const CALENDAR_FETCH_MORE_MAINTENANCES_BYDAY_SUCCESS = 'CALENDAR_FETCH_MORE_MAINTENANCES_BYDAY_SUCCESS';
export const CALENDAR_FETCH_MAINTENANCES_BYDAY_FAIL = 'CALENDAR_FETCH_MAINTENANCES_BYDAY_FAIL';

export const CALENDAR_FETCH_PDF_REPORT_START = 'CALENDAR_FETCH_PDF_REPORT_START';
export const CALENDAR_FETCH_PDF_REPORT_SUCCESS = 'CALENDAR_FETCH_PDF_REPORT_SUCCESS';
export const CALENDAR_FETCH_PDF_REPORT_FAIL = 'CALENDAR_FETCH_PDF_REPORT_FAIL';

// ----- SERVICE FORM -----------------------------------------------------------------------------------
export const SERVICE_FORM_START_POPULATE_QUESTIONS = 'SERVICE_FORM_START_POPULATE_QUESTIONS';
export const SERVICE_FORM_ANSWER_QUESTION = 'SERVICE_FORM_ANSWER_QUESTION';
export const SERVICE_FORM_ANSWER_ALL_WITH_NA = 'SERVICE_FORM_ANSWER_ALL_WITH_NA';
export const SERVICE_FORM_COMMENT_QUESTION = 'SERVICE_FORM_COMMENT_QUESTION';
export const SERVICE_FORM_ADD_FILE_QUESTION = 'SERVICE_FORM_ADD_FILE_QUESTION';
export const SERVICE_FORM_EDIT_FILE_QUESTION = 'SERVICE_FORM_EDIT_FILE_QUESTION';
export const SERVICE_FORM_DELETE_FILE_QUESTION = 'SERVICE_FORM_DELETE_FILE_QUESTION';
export const SERVICE_FORM_ADD_ACTION = 'SERVICE_FORM_ADD_ACTION';
export const SERVICE_FORM_DELETE_ACTION = 'SERVICE_FORM_DELETE_ACTION';
export const SERVICE_FORM_CLEAR_FORM = 'SERVICE_FORM_CLEAR_FORM';
export const SERVICE_FORM_SET_PLACE = 'SERVICE_FORM_SET_PLACE';
export const SERVICE_FORM_SET_PLACE_EQUIPMENT = 'SERVICE_FORM_SET_PLACE_EQUIPMENT';
export const SERVICE_FORM_SET_EQUIPMENT = 'SERVICE_FORM_SET_EQUIPMENT';
export const SERVICE_FORM_SET_EQUIPMENT_SERVICE = 'SERVICE_FORM_SET_EQUIPMENT_SERVICE';
export const SERVICE_FORM_DESCRIPTION = 'SERVICE_FORM_DESCRIPTION';
export const SERVICE_FORM_SET_DATE = 'SERVICE_FORM_SET_DATE';
export const SERVICE_FORM_EDIT_ACTION = 'SERVICE_FORM_EDIT_ACTION';
export const SERVICE_FORM_START_POPULATE_EDIT_QUESTIONS = 'SERVICE_FORM_START_POPULATE_EDIT_QUESTIONS';
export const SERVICE_FORM_CHANGE_SITE = 'SERVICE_FORM_CHANGE_SITE';
export const DELETE_ACTION = 'DELETE_ACTION';
export const SERVICE_FORM_GET_OLD_ACTIONS_START = 'SERVICE_FORM_GET_OLD_ACTIONS_START';
export const SERVICE_FORM_GET_OLD_ACTIONS_SUCCESS = 'SERVICE_FORM_GET_OLD_ACTIONS_SUCCESS';
export const SERVICE_FORM_GET_OLD_ACTIONS_FAIL = 'SERVICE_FORM_GET_OLD_ACTIONS_FAIL';


// ----- tokens ---------------------------------------------------------------------------
export const GET_TOKEN_SIGNUP = 'GET_TOKEN_SIGNUP';
export const REQUEST_TOKENS_FAIL = 'REQUEST_TOKENS_FAIL';
export const REQUEST_TOKENS_START = 'REQUEST_TOKENS_START';
export const GET_TOKEN_CONFIRM_ADD_TENANT_OR_USER = 'GET_TOKEN_CONFIRM_ADD_TENANT_OR_USER';

// ----- Quicksight -----------------------------------------------------------------------------------

export const FETCH_QUICKSIGHT_SUCCESS = 'FETCH_QUICKSIGHT_SUCCESS';
export const REQUEST_QUICKSIGHT_FAIL = 'REQUEST_QUICKSIGHT_FAIL';
export const REQUEST_QUICKSIGHT_START = 'REQUEST_QUICKSIGHT_START';
export const DELETE_QUICKSIGHT_SUCCESS = 'DELETE_QUICKSIGHT_SUCCESS';
export const UPDATE_QUICKSIGHT_SUCCESS = 'UPDATE_QUICKSIGHT_SUCCESS';
export const POST_QUICKSIGHT_SUCCESS = 'POST_QUICKSIGHT_SUCCESS';

//----filtro-----
export const SET_USERS_ROLES_FILTER = '[USERS] SET_USERS_ROLES_FILTER';
export const CLEAR_USERS_FILTER = '[USERS] CLEAR_USERS_FILTER';
export const REMOVE_USERS_ROLES_FILTER = '[USERS] REMOVE_USERS_ROLES_FILTER';

// ----- attachment files -----------------------------------------------------------------------------------
export const FETCH_ATTACHMENTFILE_BY_ID_SUCCESS = 'FETCH_ATTACHMENTFILE_BY_ID_SUCCESS';
export const REQUEST_ATTACHMENTFILE_DOCUMENT_FAIL = 'REQUEST_ATTACHMENTFILE_DOCUMENT_FAIL';
export const REQUEST_ATTACHMENTFILE_DOCUMENT_START = 'REQUEST_ATTACHMENTFILE_DOCUMENT_START';

export const FETCH_ATTACHMENTFILE_FILES_SUCCESS = 'FETCH_ATTACHMENTFILE_FILES_SUCCESS';
export const REQUEST_ATTACHMENTFILE_FILES_FAIL = 'REQUEST_ATTACHMENTFILE_FILES_FAIL';
export const REQUEST_ATTACHMENTFILE_FILES_START = 'REQUEST_ATTACHMENTFILE_FILES_START';

export const DELETE_ATTACHMENTFILE_SUCCESS = 'DELETE_ATTACHMENTFILE_SUCCESS';

// ----- support files -----------------------------------------------------------------------------------
export const REQUEST_SUPPORT_FILES_START = 'REQUEST_SUPPORT_FILES_START';
export const FETCH_SUPPORT_FILES_SUCCESS = 'FETCH_SUPPORT_FILES_SUCCESS';
export const REQUEST_SUPPORT_FILES_FAIL = 'REQUEST_SUPPORT_FILES_FAIL';
export const DELETE_SUPPORT_FILES_SUCCESS = 'DELETE_SUPPORT_FILES_SUCCESS';
export const UPDATE_SUPPORT_FILES_SUCCESS = 'UPDATE_SUPPORT_FILES_SUCCESS';
export const POST_SUPPORT_FILES_SUCCESS = 'POST_SUPPORT_FILES_SUCCESS';

//----BACKUPS APP-----------------------------------------------------------------------------------
export const REQUEST_BACKUPS_START = 'REQUEST_BACKUPS_START';
export const FETCH_BACKUPS_SUCCESS = 'FETCH_BACKUPS_SUCCESS';
export const FETCH_BACKUPS_BY_ID_SUCCESS = 'FETCH_BACKUPS_BY_ID_SUCCESS';
export const REQUEST_BACKUPS_FAIL = 'REQUEST_BACKUPS_FAIL';
export const UPDATE_BACKUPS_SUCCESS = 'UPDATE_BACKUPS_SUCCESS';
export const SET_BACKUPS_FILTER = 'SET_BACKUPS_SUCCESS';
export const FILTER_BACKUP_CLEAR = 'FILTER_BACKUP_CLEAR';

//----DATA EXPORTS-----------------------------------------------------------------------------------
export const REQUEST_DATA_EXPORTS_START = 'REQUEST_DATA_EXPORTS_START';
export const FETCH_DATA_EXPORTS_SUCCESS = 'FETCH_DATA_EXPORTS_SUCCESS';
export const REQUEST_DATA_EXPORTS_FAIL = 'REQUEST_BACKUPS_FAIL';
export const REQUEST_SIGN_DATA_EXPORT_START = 'REQUEST_SIGN_DATA_EXPORT_START';
export const FETCH_SIGN_DATA_EXPORT_SUCCESS = 'FETCH_SIGN_DATA_EXPORT_SUCCESS';
export const REQUEST_SIGN_DATA_EXPORT_FAIL = 'REQUEST_SIGN_DATA_EXPORT_FAIL';

// ----- logs -----------------------------------------------------------------------------------
export const FETCH_LOGS_SUCCESS = 'FETCH_LOGS_SUCCESS';
export const FETCH_LOGS_START = 'FETCH_LOGS_START';
export const REQUEST_LOGS_START = 'REQUEST_LOGS_START';
export const REQUEST_LOG_BY_ID_START = 'REQUEST_LOG_BY_ID_START';
export const REQUEST_LOGS_BY_EMPLOYEE_ID_START = 'REQUEST_LOGS_BY_EMPLOYEE_ID_START'
export const SET_LOGS_FILTER = 'SET_LOGS_FILTER';
export const SET_LOGS_BY_ELEMENT_ID_FILTER = 'SET_LOGS_BY_ELEMENT_ID_FILTER';
export const SET_LOGS_USERS_FILTER = 'SET_LOGS_USERS_FILTER';
export const FETCH_LOG_BY_ID_SUCCESS = 'FETCH_LOG_BY_ID_SUCCESS';
export const FETCH_LOGS_BY_EMPLOYEE_ID_SUCCESS = 'FETCH_LOGS_BY_EMPLOYEE_ID_SUCCESS';
export const POST_OPEN_DOC_LOG = 'POST_OPEN_DOC_LOG';


// ----- logs Superadmin -----------------------------------------------------------------------------------
export const FETCH_LOGS_SUPERADMIN_SUCCESS = 'FETCH_LOGS_SUPERADMIN_SUCCESS';
export const FETCH_LOGS_SUPERADMIN_START = 'FETCH_LOGS_SUPERADMIN_START';
export const REQUEST_LOGS_SUPERADMIN_START = 'REQUEST_LOGS_SUPERADMIN_START';
export const REQUEST_LOGS_SUPERADMIN_BY_ID_START = 'REQUEST_LOGS_SUPERADMIN_BY_ID_START';
export const SET_LOGS_SUPERADMIN_FILTER = 'SET_LOGS_SUPERADMIN_FILTER';
export const FETCH_LOGS_SUPERADMIN_BY_ID_SUCCESS = 'FETCH_LOGS_SUPERADMIN_BY_ID_SUCCESS';
export const FETCH_LOGS_SUPERADMIN_OPTIONS_TENANTS_SUCCESS = 'FETCH_LOGS_SUPERADMIN_OPTIONS_TENANTS_SUCCESS';
export const REQUEST_LOGS_SUPERADMIN_OPTIONS_TENANTS_START = 'REQUEST_LOGS_SUPERADMIN_OPTIONS_TENANTS_START';
export const FETCH_LOGS_SUPERADMIN_OPTIONS_TENANTS_FAIL = 'FETCH_LOGS_SUPERADMIN_OPTIONS_TENANTS_FAIL';
export const FETCH_LOGS_SUPERADMIN_OPTIONS_USERS_SUCCESS = 'FETCH_LOGS_SUPERADMIN_OPTIONS_USERS_SUCCESS';
export const REQUEST_LOGS_SUPERADMIN_OPTIONS_USERS_START = 'REQUEST_LOGS_SUPERADMIN_OPTIONS_USERS_START';
export const FETCH_LOGS_SUPERADMIN_OPTIONS_USERS_FAIL = 'FETCH_LOGS_SUPERADMIN_OPTIONS_USERS_FAIL';

// ----- Maintenance -----------------------------------------------------------------------------------
export const REQUEST_MAINTENANCE_START = 'REQUEST_MAINTENANCE_START';
export const REQUEST_MAINTENANCE_FAIL = 'REQUEST_MAINTENANCE_FAIL';
export const POST_MAINTENANCE_SUCCESS = 'POST_MAINTENANCE_SUCCESS';
export const FETCH_MAINTENANCES_BY_EQUIPMENT_START = 'FETCH_MAINTENANCES_BY_EQUIPMENT_START';
export const FETCH_MAINTENANCES_BY_EQUIPMENT_FAIL = 'FETCH_MAINTENANCES_BY_EQUIPMENT_FAIL';
export const FETCH_MAINTENANCES_BY_EQUIPMENT_SUCCESS = 'FETCH_MAINTENANCES_BY_EQUIPMENT_SUCCESS';
export const DELETE_MAINTENANCE_SUCCESS = 'DELETE_MAINTENANCE_SUCCESS';
export const FETCH_MAINTENANCE_BY_ID_SUCCESS = 'FETCH_MAINTENANCE_BY_ID_SUCCESS';
export const UPDATE_MAINTENANCE_SUCCESS = 'UPDATE_MAINTENANCE_SUCCESS';
export const CLEAR_MAINTENANCE_INFO = 'CLEAR_MAINTENANCE_INFO';
export const FETCH_MAINTENANCES_BY_EQUIPMENT_INFINITE_SCROLL_START = 'FETCH_MAINTENANCES_BY_EQUIPMENT_INFINITE_SCROLL_START';
export const FETCH_MAINTENANCES_BY_EQUIPMENT_INFINITE_SCROLL_SUCCESS = 'FETCH_MAINTENANCES_BY_EQUIPMENT_INFINITE_SCROLL_SUCCESS';
export const SET_MAINTENANCES_FILTER = 'SET_MAINTENANCES_FILTER';
export const FETCH_MAINTENANCES_SUCCESS = 'FETCH_MAINTENANCES_SUCCESS';
export const FILTER_MAINTENANCE_EQUIPMENTS = 'FILTER_MAINTENANCE_EQUIPMENTS';
export const FILTER_MAINTENANCE_EQUIPMENTS_REMOVE = 'FILTER_MAINTENANCE_EQUIPMENTS_REMOVE';
export const FILTER_MAINTENANCE_CREATED_AT = 'FILTER_MAINTENANCE_CREATED_AT';
export const FILTER_MAINTENANCE_CREATED_AT_REMOVE = 'FILTER_MAINTENANCE_CREATED_AT_REMOVE';
export const FILTER_MAINTENANCE_SEND_TO_MAINTENANCE_DATE = 'FILTER_MAINTENANCE_SEND_TO_MAINTENANCE_DATE';
export const FILTER_MAINTENANCE_SEND_TO_MAINTENANCE_DATE_REMOVE = 'FILTER_MAINTENANCE_SEND_TO_MAINTENANCE_DATE_REMOVE';
export const FILTER_MAINTENANCE_RETURN_FROM_MAINTENANCE_DATE = 'FILTER_MAINTENANCE_RETURN_FROM_MAINTENANCE_DATE';
export const FILTER_MAINTENANCE_RETURN_FROM_MAINTENANCE_DATE_REMOVE = 'FILTER_MAINTENANCE_RETURN_FROM_MAINTENANCE_DATE_REMOVE';
export const FILTER_MAINTENANCE_WARRANTY = 'FILTER_MAINTENANCE_WARRANTY';
export const FILTER_MAINTENANCE_WARRANTY_REMOVE = 'FILTER_MAINTENANCE_WARRANTY_REMOVE';
export const FILTER_MAINTENANCE_EXPIRATION = 'FILTER_MAINTENANCE_EXPIRATION';
export const FILTER_MAINTENANCE_EXPIRATION_REMOVE = 'FILTER_MAINTENANCE_EXPIRATION_REMOVE';
export const FILTER_MAINTENANCE_CLEAR = 'FILTER_MAINTENANCE_CLEAR';
export const FILTER_MAINTENANCE_PLACES = 'FILTER_MAINTENANCE_PLACES';
export const FILTER_MAINTENANCE_PLACES_REMOVE = 'FILTER_MAINTENANCE_PLACES_REMOVE';
export const FILTER_MAINTENANCE_STATUS = 'FILTER_MAINTENANCE_STATUS';
export const FILTER_MAINTENANCE_STATUS_REMOVE = 'FILTER_MAINTENANCE_STATUS_REMOVE';

// ------ Reports ----------------------------------------------------------------------------------------
export const REPORTS_FETCH_EQUIPMENT_MODELS_START = 'REPORTS_FETCH_EQUIPMENT_MODELS_START';
export const REPORTS_FETCH_EQUIPMENT_MODELS_SUCESS = 'REPORTS_FETCH_EQUIPMENT_MODELS_SUCESS';
export const REPORTS_FETCH_EQUIPMENT_MODELS_FAIL = 'REPORTS_FETCH_EQUIPMENT_MODELS_FAIL';
export const REPORTS_FETCH_EQUIPMENT_MODEL_BY_ID_START = 'REPORTS_FETCH_EQUIPMENT_MODEL_BY_ID_START';
export const REPORTS_FETCH_EQUIPMENT_MODEL_BY_ID_SUCCESS = 'REPORTS_FETCH_EQUIPMENT_MODEL_BY_ID_SUCCESS';
export const REPORTS_FETCH_EQUIPMENT_MODEL_BY_ID_FAIL = 'REPORTS_FETCH_EQUIPMENT_MODEL_BY_ID_FAIL';
export const REPORTS_CLEAR_SELECTED_EQUIPMENT_MODEL = 'REPORTS_CLEAR_SELECTED_EQUIPMENT_MODEL';


// ------ Equipments Public ----------------------------------------------------------------------------------------
export const REQUEST_EQUIPMENTS_PUBLIC_START = 'REQUEST_EQUIPMENTS_PUBLIC_START';
export const REQUEST_EQUIPMENTS_PUBLIC_FAIL = 'REQUEST_EQUIPMENTS_PUBLIC_FAIL';
export const FETCH_EQUIPMENTS_PUBLIC_BY_ID_SUCCESS = 'FETCH_EQUIPMENTS_PUBLIC_BY_ID_SUCCESS';

// --------------- EMAIL LOGS --------------------------------------------------------------------------------

export const FETCH_EMAIL_LOGS_SUCCESS = 'FETCH_EMAIL_LOGS_SUCCESS';
export const REQUEST_EMAIL_LOGS_START = 'REQUEST_EMAIL_LOGS_START';
export const REQUEST_EMAIL_LOG_BY_ID_START = 'REQUEST_EMAIL_LOG_BY_ID_START';
export const FETCH_EMAIL_LOG_BY_ID_SUCCESS = 'FETCH_EMAIL_LOG_BY_ID_SUCCESS';
export const SET_EMAIL_LOGS_FILTER = 'SET_EMAIL_LOGS_FILTER';
export const REQUEST_EMAIL_LOGS_OPTIONS_TENANTS_START = 'REQUEST_EMAIL_LOGS_OPTIONS_TENANTS_START';
export const FETCH_EMAIL_LOGS_OPTIONS_TENANTS_SUCCESS = 'FETCH_EMAIL_LOGS_OPTIONS_TENANTS_SUCCESS';
export const FETCH_EMAIL_LOGS_OPTIONS_TENANTS_FAIL = 'FETCH_EMAIL_LOGS_OPTIONS_TENANTS_FAIL';

// --------------- EXPIRED SERVICES --------------------------------------------------------------------------------
export const SET_EXPIRED_SERVICES_FILTER = 'SET_EXPIRED_SERVICES_FILTER'
export const FETCH_EXPIRED_SERVICE_SUCCESS = 'FETCH_EXPIRED_SERVICE_SUCCESS';
export const REQUEST_EXPIRED_SERVICE_FAIL = 'REQUEST_EXPIRED_SERVICE_FAIL';
export const FETCH_EXPIRED_SERVICES_BADGE_SUCCESS = 'FETCH_EXPIRED_SERVICES_BADGE_SUCCESS';
export const REQUEST_EXPIRED_SERVICE_BADGE_FAIL = 'REQUEST_EXPIRED_SERVICE_BADGE_FAIL';
export const REQUEST_EXPIRED_SERVICE_BADGE_START = 'REQUEST_EXPIRED_SERVICE_BADGE_START';
export const REQUEST_EXPIRED_SERVICE_START = 'REQUEST_EXPIRED_SERVICE_START';
// filter
export const FILTER_EXPIRED_SERVICE_TYPES = 'FILTER_EXPIRED_SERVICE_TYPES';
export const FILTER_EXPIRED_SERVICE_TYPES_REMOVE = 'FILTER_EXPIRED_SERVICE_TYPES_REMOVE';
export const FILTER_EXPIRED_SERVICES_EQUIPMENT_GROUPS = 'FILTER_EXPIRED_SERVICES_EQUIPMENT_GROUPS';
export const FILTER_EXPIRED_SERVICES_EQUIPMENT_GROUPS_REMOVE = 'FILTER_EXPIRED_SERVICES_EQUIPMENT_GROUPS_REMOVE';
export const FILTER_EXPIRED_SERVICES_PLACES = 'FILTER_EXPIRED_SERVICES_PLACES';
export const FILTER_EXPIRED_SERVICES_PLACES_REMOVE = 'FILTER_EXPIRED_SERVICES_PLACES_REMOVE';


export const FILTER_EXPIRED_SERVICES_MODELS = 'FILTER_EXPIRED_SERVICES_MODELS';
export const FILTER_EXPIRED_SERVICES_MODELS_REMOVE = 'FILTER_EXPIRED_SERVICES_MODELS_REMOVE';
export const FILTER_EXPIRED_SERVICES_AREAS = 'FILTER_EXPIRED_SERVICES_AREAS';
export const FILTER_EXPIRED_SERVICES_AREAS_REMOVE = 'FILTER_EXPIRED_SERVICES_AREAS_REMOVE';
export const FILTER_EXPIRED_SERVICES_COMPANIES = 'FILTER_EXPIRED_SERVICES_COMPANIES';
export const FILTER_EXPIRED_SERVICES_COMPANIES_REMOVE = 'FILTER_EXPIRED_SERVICES_COMPANIES_REMOVE';
export const FILTER_EXPIRED_SERVICES_FREQUENCIES = 'FILTER_EXPIRED_SERVICES_FREQUENCIES';
export const FILTER_EXPIRED_SERVICES_FREQUENCIES_REMOVE = 'FILTER_EXPIRED_SERVICES_FREQUENCIES_REMOVE';
export const FILTER_EXPIRED_SERVICES_CLEAR = 'FILTER_EXPIRED_SERVICES_CLEAR';
export const FILTER_EXPIRED_SERVICE_START_DATE = 'FILTER_EXPIRED_SERVICE_START_DATE';
export const FILTER_EXPIRED_SERVICE_START_DATE_REMOVE = 'FILTER_EXPIRED_SERVICE_START_DATE_REMOVE';
export const FILTER_EXPIRED_SERVICE_END_DATE = 'FILTER_EXPIRED_SERVICE_END_DATE';
export const FILTER_EXPIRED_SERVICE_END_DATE_REMOVE = 'FILTER_EXPIRED_SERVICE_END_DATE_REMOVE';

export const EXPIRED_SERVICES_FILTER_SHOW_MANDATORY_SERVICES = 'EXPIRED_SERVICES_FILTER_SHOW_MANDATORY_SERVICES';
export const EXPIRED_SERVICES_FILTER_SHOW_NON_MANDATORY_SERVICES = 'EXPIRED_SERVICES_FILTER_SHOW_NON_MANDATORY_SERVICES';

// CREATESERVICE ---------------------------------------------------------------------------------

export const CREATE_SERVICE_FETCH_PLACES_START = 'CREATE_SERVICE_FETCH_PLACES_START';
export const CREATE_SERVICE_FETCH_PLACES_SUCCESS = 'CREATE_SERVICE_FETCH_PLACES_SUCCESS';
export const CREATE_SERVICE_FETCH_PLACES_FAIL = 'CREATE_SERVICE_FETCH_PLACES_FAIL';

export const CREATE_SERVICE_FETCH_EQUIPMENT_MODEL_START = 'CREATE_SERVICE_FETCH_EQUIPMENT_MODEL_START';
export const CREATE_SERVICE_FETCH_EQUIPMENT_MODEL_SUCCESS = 'CREATE_SERVICE_FETCH_EQUIPMENT_MODEL_SUCCESS';
export const CREATE_SERVICE_FETCH_EQUIPMENT_MODEL_FAIL = 'CREATE_SERVICE_FETCH_EQUIPMENT_MODEL_FAIL';

export const CREATE_SERVICE_FETCH_GROUPS_START = 'CREATE_SERVICE_FETCH_GROUPS_START';
export const CREATE_SERVICE_FETCH_GROUPS_SUCCESS = 'CREATE_SERVICE_FETCH_GROUPS_SUCCESS';
export const CREATE_SERVICE_FETCH_GROUPS_FAIL = 'CREATE_SERVICE_FETCH_GROUPS_FAIL';

export const CREATE_SERVICE_FETCH_AREAS_START = 'CREATE_SERVICE_FETCH_AREAS_START';
export const CREATE_SERVICE_FETCH_AREAS_SUCCESS = 'CREATE_SERVICE_FETCH_AREAS_SUCCESS';
export const CREATE_SERVICE_FETCH_AREAS_FAIL = 'CREATE_SERVICE_FETCH_AREAS_FAIL';

export const CREATE_SERVICE_FETCH_COMPANIES_START = 'CREATE_SERVICE_FETCH_COMPANIES_START';
export const CREATE_SERVICE_FETCH_COMPANIES_SUCCESS = 'CREATE_SERVICE_FETCH_COMPANIES_SUCCESS';
export const CREATE_SERVICE_FETCH_COMPANIES_FAIL = 'CREATE_SERVICE_FETCH_COMPANIES_FAIL';

export const CREATE_SERVICE_SET_EQUIPMENTS_TABLE_FILTERS = 'CREATE_SERVICE_SET_EQUIPMENTS_TABLE_FILTERS';

export const CREATE_SERVICE_REMOVE_PLACES_FILTER = 'CREATE_SERVICE_REMOVE_PLACES_FILTER';
export const CREATE_SERVICE_REMOVE_AREAS_FILTER = 'CREATE_SERVICE_REMOVE_AREAS_FILTER';
export const CREATE_SERVICE_REMOVE_COMPANIES_FILTER = 'CREATE_SERVICE_REMOVE_COMPANIES_FILTER';
export const CREATE_SERVICE_REMOVE_EQUIPMENT_GROUP_FILTER = 'CREATE_SERVICE_REMOVE_EQUIPMENT_GROUP_FILTER';
export const CREATE_SERVICE_REMOVE_EQUIPMENT_MODEL_FILTER = 'CREATE_SERVICE_REMOVE_EQUIPMENT_MODEL_FILTER';
export const CREATE_SERVICE_FILTER_STATUS = 'CREATE_SERVICE_FILTER_STATUS';
export const CREATE_SERVICE_CLEAR_ALL_FILTERS = 'CREATE_SERVICE_CLEAR_ALL_FILTERS';

export const CREATE_SERVICE_FETCH_EQUIPMENTS_START = 'CREATE_SERVICE_FETCH_EQUIPMENTS_START';
export const CREATE_SERVICE_FETCH_EQUIPMENTS_SUCCESS = 'CREATE_SERVICE_FETCH_EQUIPMENTS_SUCCESS';
export const CREATE_SERVICE_FETCH_EQUIPMENTS_FAIL = 'CREATE_SERVICE_FETCH_EQUIPMENTS_FAIL';
export const CREATE_SERVICE_SELECT_EQUIPMENT = 'CREATE_SERVICE_SELECT_EQUIPMENT';
export const CREATE_SERVICE_FETCH_EQUIPMENT_SERVICES_START ='CREATE_SERVICE_FETCH_EQUIPMENT_SERVICES_START'; 
export const CREATE_SERVICE_FETCH_EQUIPMENT_SERVICES_SUCCESS ='CREATE_SERVICE_FETCH_EQUIPMENT_SERVICES_SUCCESS';
export const CREATE_SERVICE_FETCH_EQUIPMENT_SERVICES_FAIL ='CREATE_SERVICE_FETCH_EQUIPMENT_SERVICES_FAIL';

export const CREATE_SERVICE_FETCH_QUESTIONS_START = 'CREATE_SERVICE_FETCH_QUESTIONS_START';
export const CREATE_SERVICE_FETCH_QUESTIONS_SUCCESS = 'CREATE_SERVICE_FETCH_QUESTIONS_SUCCESS';
export const CREATE_SERVICE_FETCH_QUESTIONS_FAIL = 'CREATE_SERVICE_FETCH_QUESTIONS_FAIL';

export const CREATE_SERVICE_GET_OLD_ACTIONS_START = 'CREATE_SERVICE_GET_OLD_ACTIONS_START';
export const CREATE_SERVICE_GET_OLD_ACTIONS_SUCCESS = 'CREATE_SERVICE_GET_OLD_ACTIONS_SUCCESS';
export const CREATE_SERVICE_GET_OLD_ACTIONS_FAIL = 'CREATE_SERVICE_GET_OLD_ACTIONS_FAIL';

export const CREATE_SERVICE_CHANGE_SERVICE_DATE = 'CREATE_SERVICE_CHANGE_SERVICE_DATE';

export const CREATE_SERVICE_CHANGE_QUESTION_ANSWER = 'CREATE_SERVICE_CHANGE_QUESTION_ANSWER';
export const CREATE_SERVICE_CHANGE_QUESTION_COMMENT = 'CREATE_SERVICE_CHANGE_QUESTION_COMMENT';

export const CREATE_SERVICE_ADD_QUESTION_ACTION = 'CREATE_SERVICE_ADD_QUESTION_ACTION';
export const CREATE_SERVICE_EDIT_QUESTION_ACTION = 'CREATE_SERVICE_EDIT_QUESTION_ACTION';
export const CREATE_SERVICE_DELETE_QUESTION_ACTION = 'CREATE_SERVICE_DELETE_QUESTION_ACTION';

export const CREATE_SERVICE_ADD_QUESTION_FILE = 'CREATE_SERVICE_ADD_QUESTION_FILE';
export const CREATE_SERVICE_EDIT_QUESTION_FILE = 'CREATE_SERVICE_EDIT_QUESTION_FILE';
export const CREATE_SERVICE_DELETE_QUESTION_FILE = 'CREATE_SERVICE_DELETE_QUESTION_FILE';

export const CREATE_SERVICE_ADD_FILE = 'CREATE_SERVICE_ADD_FILE';
export const CREATE_SERVICE_EDIT_FILE = 'CREATE_SERVICE_EDIT_FILE';
export const CREATE_SERVICE_DELETE_FILE = 'CREATE_SERVICE_DELETE_FILE';

export const CREATE_SERVICE_ADD_SIGNATURE_START = 'CREATE_SERVICE_ADD_SIGNATURE_START';
export const CREATE_SERVICE_ADD_SIGNATURE_SUCCESS = 'CREATE_SERVICE_ADD_SIGNATURE_SUCCESS';
export const CREATE_SERVICE_ADD_SIGNATURE_FAIL = 'CREATE_SERVICE_ADD_SIGNATURE_FAIL';

export const CREATE_SERVICE_CLEAR = 'CREATE_SERVICE_CLEAR';

export const CREATE_SERVICE_SELECT_EQUIPMENT_SERVICE = 'CREATE_SERVICE_SELECT_EQUIPMENT_SERVICE';

export const CREATE_SERVICE_POST_SERVICE_START = 'CREATE_SERVICE_POST_SERVICE_START';
export const CREATE_SERVICE_POST_SERVICE_SUCCESS = 'CREATE_SERVICE_POST_SERVICE_SUCCESS';
export const CREATE_SERVICE_POST_SERVICE_FAIL = 'CREATE_SERVICE_POST_SERVICE_FAIL';

export const CREATE_SERVICE_ANSWER_ALL_QUESTIONS_NA = 'CREATE_SERVICE_ANSWER_ALL_QUESTIONS_NA';

export const CREATE_SERVICE_CLEAR_SERVICE_FILES_SIGNATURE = 'CREATE_SERVICE_CLEAR_SERVICE_FILES_SIGNATURE';

export const CREATE_SERVICE_REFRESH_OLD_ACTIONS_START = 'CREATE_SERVICE_REFRESH_OLD_ACTIONS_START';
export const CREATE_SERVICE_REFRESH_OLD_ACTIONS_SUCCESS = 'CREATE_SERVICE_REFRESH_OLD_ACTIONS_SUCCESS';
export const CREATE_SERVICE_REFRESH_OLD_ACTIONS_FAIL = 'CREATE_SERVICE_REFRESH_OLD_ACTIONS_FAIL';

export const CREATE_SERVICE_ADD_SIGNATURE_NAME = 'CREATE_SERVICE_ADD_SIGNATURE_NAME';
export const CREATE_SERVICE_ADD_SIGNATURE_COMPLEMENT = 'CREATE_SERVICE_ADD_SIGNATURE_COMPLEMENT';

export const CREATE_SERVICE_REMOVE_SIGNATURE = 'CREATE_SERVICE_REMOVE_SIGNATURE';

export const CREATE_SERVICE_DRAFT_START = 'CREATE_SERVICE_DRAFT_START';
export const CREATE_SERVICE_DRAFT_SUCCESS = 'CREATE_SERVICE_DRAFT_SUCCESS';
export const CREATE_SERVICE_DRAFT_FAIL = 'CREATE_SERVICE_DRAFT_FAIL';

export const CREATE_SERVICE_UPDATE_DRAFT_START = 'CREATE_SERVICE_UPDATE_DRAFT_START';
export const CREATE_SERVICE_UPDATE_DRAFT_SUCCESS = 'CREATE_SERVICE_UPDATE_DRAFT_SUCCESS';
export const CREATE_SERVICE_UPDATE_DRAFT_FAIL = 'CREATE_SERVICE_UPDATE_DRAFT_FAIL';

export const CREATE_SERVICE_COMPLETE_DRAFT_START = 'CREATE_SERVICE_COMPLETE_DRAFT_START';
export const CREATE_SERVICE_COMPLETE_DRAFT_SUCCESS = 'CREATE_SERVICE_COMPLETE_DRAFT_SUCCESS';
export const CREATE_SERVICE_COMPLETE_DRAFT_FAIL = 'CREATE_SERVICE_COMPLETE_DRAFT_FAIL';

export const CREATE_SERVICE_DELETE_DRAFT_START = 'CREATE_SERVICE_DELETE_DRAFT_START';
export const CREATE_SERVICE_DELETE_DRAFT_SUCCESS = 'CREATE_SERVICE_DELETE_DRAFT_SUCCESS';
export const CREATE_SERVICE_DELETE_DRAFT_FAIL = 'CREATE_SERVICE_DELETE_DRAFT_FAIL';

export const CREATE_SERVICE_FETCH_SERVICE_DRAFTS_START = 'CREATE_SERVICE_FETCH_SERVICE_DRAFTS_START';
export const CREATE_SERVICE_FETCH_SERVICE_DRAFTS_SUCCESS = 'CREATE_SERVICE_FETCH_SERVICE_DRAFTS_SUCCESS';
export const CREATE_SERVICE_FETCH_SERVICE_DRAFTS_FAIL = 'CREATE_SERVICE_FETCH_SERVICE_DRAFTS_FAIL';

export const CREATE_SERVICE_LOAD_DRAFT_START = 'CREATE_SERVICE_LOAD_DRAFT_START';
export const CREATE_SERVICE_LOAD_DRAFT_SUCCESS = 'CREATE_SERVICE_LOAD_DRAFT_SUCCESS';
export const CREATE_SERVICE_LOAD_DRAFT_FAIL = 'CREATE_SERVICE_LOAD_DRAFT_FAIL';

export const CREATE_SERVICE_SET_SERVICE_DRAFT_ID = 'CREATE_SERVICE_SET_SERVICE_DRAFT_ID';

// EDIT SERVICE  ---------------------------------------------------------------------------------

export const EDIT_SERVICE_SELECT_SERVICE = 'EDIT_SERVICE_SELECT_SERVICE';

export const EDIT_SERVICE_FETCH_SERVICE_START = 'EDIT_SERVICE_FETCH_SERVICE_START';
export const EDIT_SERVICE_FETCH_SERVICE_SUCCESS = 'EDIT_SERVICE_FETCH_SERVICE_SUCCESS';
export const EDIT_SERVICE_FETCH_SERVICE_FAIL = 'EDIT_SERVICE_FETCH_SERVICE_FAIL';

export const EDIT_SERVICE_CHANGE_SERVICE_DATE = 'EDIT_SERVICE_CHANGE_SERVICE_DATE';
export const EDIT_SERVICE_CHANGE_SERVICE_DESCRIPTION = 'EDIT_SERVICE_CHANGE_SERVICE_DESCRIPTION';
export const EDIT_SERVICE_CHANGE_QUESTION_ANSWER = 'EDIT_SERVICE_CHANGE_QUESTION_ANSWER';
export const EDIT_SERVICE_CHANGE_QUESTION_COMMENT = 'EDIT_SERVICE_CHANGE_QUESTION_COMMENT';
export const EDIT_SERVICE_ADD_QUESTION_ACTION = 'EDIT_SERVICE_ADD_QUESTION_ACTION';
export const EDIT_SERVICE_EDIT_QUESTION_ACTION = 'EDIT_SERVICE_EDIT_QUESTION_ACTION';
export const EDIT_SERVICE_DELETE_QUESTION_ACTION = 'EDIT_SERVICE_DELETE_QUESTION_ACTION';
export const EDIT_SERVICE_ADD_QUESTION_FILE = 'EDIT_SERVICE_ADD_QUESTION_FILE';
export const EDIT_SERVICE_EDIT_QUESTION_FILE = 'EDIT_SERVICE_EDIT_QUESTION_FILE';
export const EDIT_SERVICE_DELETE_QUESTION_FILE = 'EDIT_SERVICE_DELETE_QUESTION_FILE';
export const EDIT_SERVICE_ADD_FILE = 'EDIT_SERVICE_ADD_FILE';
export const EDIT_SERVICE_EDIT_FILE = 'EDIT_SERVICE_EDIT_FILE';
export const EDIT_SERVICE_DELETE_FILE = 'EDIT_SERVICE_DELETE_FILE';
export const EDIT_SERVICE_ANSWER_ALL_QUESTIONS_NA = 'EDIT_SERVICE_ANSWER_ALL_QUESTIONS_NA';
export const EDIT_SERVICE_REQUEST_SERVICES_START = 'EDIT_SERVICE_REQUEST_SERVICES_START';
export const EDIT_SERVICE_REQUEST_SERVICES_FAIL = 'EDIT_SERVICE_REQUEST_SERVICES_FAIL';
export const EDIT_SERVICE_UPDATE_SERVICES_SUCCESS = 'EDIT_SERVICE_UPDATE_SERVICES_SUCCESS';
export const EDIT_SERVICE_ADD_SIGNATURE_START = 'EDIT_SERVICE_ADD_SIGNATURE_START';
export const EDIT_SERVICE_ADD_SIGNATURE_SUCCESS = 'EDIT_SERVICE_ADD_SIGNATURE_SUCCESS';
export const EDIT_SERVICE_ADD_SIGNATURE_FAIL = 'EDIT_SERVICE_ADD_SIGNATURE_FAIL';
export const EDIT_SERVICE_GET_OLD_ACTIONS_START = 'EDIT_SERVICE_GET_OLD_ACTIONS_START';
export const EDIT_SERVICE_GET_OLD_ACTIONS_SUCCESS = 'EDIT_SERVICE_GET_OLD_ACTIONS_SUCCESS';
export const EDIT_SERVICE_GET_OLD_ACTIONS_FAIL = 'EDIT_SERVICE_GET_OLD_ACTIONS_FAIL';
export const EDIT_SERVICE_CLEAR_STATE = 'EDIT_SERVICE_CLEAR_STATE';
export const EDIT_SERVICE_DOWNLOAD_REPORT_SUCCESS = 'EDIT_SERVICE_DOWNLOAD_REPORT_SUCCESS';
export const EDIT_SERVICE_DOWNLOAD_REPORT_FAIL = 'EDIT_SERVICE_DOWNLOAD_REPORT_FAIL';
export const EDIT_SERVICE_DOWNLOAD_REPORT_START = 'EDIT_SERVICE_DOWNLOAD_REPORT_START';

// SCHEDULED SERVICES  ---------------------------------------------------------------------------------
// SCHEDULED SERVICES PLANNER
export const SCHEDULED_SERVICES_GET_USERS_START = 'SCHEDULED_SERVICES_GET_USERS_START';
export const SCHEDULED_SERVICES_GET_USERS_SUCCESS = 'SCHEDULED_SERVICES_GET_USERS_SUCCESS';
export const SCHEDULED_SERVICES_GET_USERS_FAIL = 'SCHEDULED_SERVICES_GET_USERS_FAIL';
export const SCHEDULED_SERVICES_GET_SERVICES_FOR_SCHEDULING_START = 'SCHEDULED_SERVICES_GET_SERVICES_FOR_SCHEDULING_START';
export const SCHEDULED_SERVICES_GET_SERVICES_FOR_SCHEDULING_SUCCESS = 'SCHEDULED_SERVICES_GET_SERVICES_FOR_SCHEDULING_SUCCESS';
export const SCHEDULED_SERVICES_GET_SERVICES_FOR_SCHEDULING_FAIL = 'SCHEDULED_SERVICES_GET_SERVICES_FOR_SCHEDULING_FAIL';
export const SCHEDULED_SERVICES_POST_START = 'SCHEDULED_SERVICES_POST_START';
export const SCHEDULED_SERVICES_POST_SUCCESS = 'SCHEDULED_SERVICES_POST_SUCCESS';
export const SCHEDULED_SERVICES_POST_FAIL = 'SCHEDULED_SERVICES_POST_FAIL';
export const SCHEDULED_SERVICES_COUNT_BY_USERS_AND_DAYS_START = 'SCHEDULED_SERVICES_COUNT_BY_USERS_AND_DAYS_START';
export const SCHEDULED_SERVICES_COUNT_BY_USERS_AND_DAYS_SUCCESS = 'SCHEDULED_SERVICES_COUNT_BY_USERS_AND_DAYS_SUCCESS';
export const SCHEDULED_SERVICES_COUNT_BY_USERS_AND_DAYS_FAIL = 'SCHEDULED_SERVICES_COUNT_BY_USERS_AND_DAYS_FAIL';
export const SCHEDULED_SERVICES_GET_BY_USER_AND_DAY_START = 'SCHEDULED_SERVICES_GET_BY_USER_AND_DAY_START';
export const SCHEDULED_SERVICES_GET_BY_USER_AND_DAY_SUCCESS = 'SCHEDULED_SERVICES_GET_BY_USER_AND_DAY_SUCCESS';
export const SCHEDULED_SERVICES_GET_BY_USER_AND_DAY_FAIL = 'SCHEDULED_SERVICES_GET_BY_USER_AND_DAY_FAIL';
export const SCHEDULED_SERVICES_OPEN_CLOSE_SERVICES_BY_USER_AND_DAY_MODAL = 'SCHEDULED_SERVICES_OPEN_CLOSE_SERVICES_BY_USER_AND_DAY_MODAL';
export const SCHEDULED_SERVICES_SELECT_USER_AND_DATE = 'SCHEDULED_SERVICES_SELECT_USER_AND_DATE';
export const SCHEDULED_SERVICES_SOFT_DELETE_START = 'SCHEDULED_SERVICES_SOFT_DELETE_START';
export const SCHEDULED_SERVICES_SOFT_DELETE_SUCCESS = 'SCHEDULED_SERVICES_SOFT_DELETE_SUCCESS';
export const SCHEDULED_SERVICES_SOFT_DELETE_FAIL = 'SCHEDULED_SERVICES_SOFT_DELETE_FAIL';
export const SCHEDULED_SERVICES_SET_USERS_FILTERS = 'SCHEDULED_SERVICES_SET_USERS_FILTERS';
export const SCHEDULED_SERVICES_CLEAR_USERS_FILTERS = 'SCHEDULED_SERVICES_CLEAR_USERS_FILTERS';
export const SCHEDULED_SERVICES_SET_SERVICES_FOR_SCHEDULING_FILTERS = 'SCHEDULED_SERVICES_SET_SERVICES_FOR_SCHEDULING_FILTERS';
export const SCHEDULED_SERVICES_CLEAR_SERVICES_FOR_SCHEDULING_FILTERS = 'SCHEDULED_SERVICES_CLEAR_SERVICES_FOR_SCHEDULING_FILTERS';

export const SCHEDULED_SERVICES_FETCH_PLACES_START = 'SCHEDULED_SERVICES_FETCH_PLACES_START';
export const SCHEDULED_SERVICES_FETCH_PLACES_SUCCESS = 'SCHEDULED_SERVICES_FETCH_PLACES_SUCCESS';
export const SCHEDULED_SERVICES_FETCH_PLACES_FAIL = 'SCHEDULED_SERVICES_FETCH_PLACES_FAIL';

export const SCHEDULED_SERVICES_FETCH_EQUIPMENT_MODEL_START = 'SCHEDULED_SERVICES_FETCH_EQUIPMENT_MODEL_START';
export const SCHEDULED_SERVICES_FETCH_EQUIPMENT_MODEL_SUCCESS = 'SCHEDULED_SERVICES_FETCH_EQUIPMENT_MODEL_SUCCESS';
export const SCHEDULED_SERVICES_FETCH_EQUIPMENT_MODEL_FAIL = 'SCHEDULED_SERVICES_FETCH_EQUIPMENT_MODEL_FAIL';

export const SCHEDULED_SERVICES_FETCH_EQUIPMENTS_START = 'SCHEDULED_SERVICES_FETCH_EQUIPMENTS_START';
export const SCHEDULED_SERVICES_FETCH_EQUIPMENTS_SUCCESS = 'SCHEDULED_SERVICES_FETCH_EQUIPMENTS_SUCCESS';
export const SCHEDULED_SERVICES_FETCH_EQUIPMENTS_FAIL = 'SCHEDULED_SERVICES_FETCH_EQUIPMENTS_FAIL';

export const SCHEDULED_SERVICES_FETCH_GROUPS_START = 'SCHEDULED_SERVICES_FETCH_GROUPS_START';
export const SCHEDULED_SERVICES_FETCH_GROUPS_SUCCESS = 'SCHEDULED_SERVICES_FETCH_GROUPS_SUCCESS';
export const SCHEDULED_SERVICES_FETCH_GROUPS_FAIL = 'SCHEDULED_SERVICES_FETCH_GROUPS_FAIL';

export const SCHEDULED_SERVICES_FETCH_AREAS_START = 'SCHEDULED_SERVICES_FETCH_AREAS_START';
export const SCHEDULED_SERVICES_FETCH_AREAS_SUCCESS = 'SCHEDULED_SERVICES_FETCH_AREAS_SUCCESS';
export const SCHEDULED_SERVICES_FETCH_AREAS_FAIL = 'SCHEDULED_SERVICES_FETCH_AREAS_FAIL';

export const SCHEDULED_SERVICES_FETCH_COMPANIES_START = 'SCHEDULED_SERVICES_FETCH_COMPANIES_START';
export const SCHEDULED_SERVICES_FETCH_COMPANIES_SUCCESS = 'SCHEDULED_SERVICES_FETCH_COMPANIES_SUCCESS';
export const SCHEDULED_SERVICES_FETCH_COMPANIES_FAIL = 'SCHEDULED_SERVICES_FETCH_COMPANIES_FAIL';

export const SCHEDULED_SERVICES_FETCH_FREQUENCIES_START = 'SCHEDULED_SERVICES_FETCH_FREQUENCIES_START';
export const SCHEDULED_SERVICES_FETCH_FREQUENCIES_SUCCESS = 'SCHEDULED_SERVICES_FETCH_FREQUENCIES_SUCCESS';
export const SCHEDULED_SERVICES_FETCH_FREQUENCIES_FAIL = 'SCHEDULED_SERVICES_FETCH_FREQUENCIES_FAIL';

export const SCHEDULED_SERVICES_FETCH_SERVICE_TYPES_START = 'SCHEDULED_SERVICES_FETCH_SERVICE_TYPES_START';
export const SCHEDULED_SERVICES_FETCH_SERVICE_TYPES_SUCCESS = 'SCHEDULED_SERVICES_FETCH_SERVICE_TYPES_SUCCESS';
export const SCHEDULED_SERVICES_FETCH_SERVICE_TYPES_FAIL = 'SCHEDULED_SERVICES_FETCH_SERVICE_TYPES_FAIL';

export const SCHEDULED_SERVICES_FETCH_USERS_START = 'SCHEDULED_SERVICES_FETCH_USERS_START';
export const SCHEDULED_SERVICES_FETCH_USERS_SUCCESS = 'SCHEDULED_SERVICES_FETCH_USERS_SUCCESS';
export const SCHEDULED_SERVICES_FETCH_USERS_FAIL = 'SCHEDULED_SERVICES_FETCH_USERS_FAIL';

export const SCHEDULED_SERVICES_SELECT_SITE = 'SCHEDULED_SERVICES_SELECT_SITE';

export const SCHEDULED_SERVICES_GET_MORE_SERVICES_FOR_SCHEDULING_START = 'SCHEDULED_SERVICES_GET_MORE_SERVICES_FOR_SCHEDULING_START';
export const SCHEDULED_SERVICES_GET_MORE_SERVICES_FOR_SCHEDULING_SUCCESS = 'SCHEDULED_SERVICES_GET_MORE_SERVICES_FOR_SCHEDULING_SUCCESS';
export const SCHEDULED_SERVICES_GET_MORE_SERVICES_FOR_SCHEDULING_FAIL = 'SCHEDULED_SERVICES_GET_MORE_SERVICES_FOR_SCHEDULING_FAIL';

export const SCHEDULED_SERVICES_TOGGLE_SHOW_SELECT_MANY_CHECKBOXES = 'SCHEDULED_SERVICES_TOGGLE_SHOW_SELECT_MANY_CHECKBOXES';

export const SCHEDULED_SERVICES_ADD_SERVICE_TO_BE_SCHEDULED = 'SCHEDULED_SERVICES_ADD_SERVICE_TO_BE_SCHEDULED';
export const SCHEDULED_SERVICES_REMOVE_SERVICE_TO_BE_SCHEDULED = 'SCHEDULED_SERVICES_REMOVE_SERVICE_TO_BE_SCHEDULED';
export const SCHEDULED_SERVICES_CLEAR_SERVICES_TO_BE_SCHEDULED = 'SCHEDULED_SERVICES_CLEAR_SERVICES_TO_BE_SCHEDULED';
export const SCHEDULED_SERVICES_ADD_ALL_SERVICES_TO_BE_SCHEDULED = 'SCHEDULED_SERVICES_ADD_ALL_SERVICES_TO_BE_SCHEDULED';

// SCHEDULED SERVICES CALENDAR
export const SCHEDULED_SERVICES_CLEAR_CALENDAR_FILTERS = 'SCHEDULED_SERVICES_CLEAR_CALENDAR_FILTERS';
export const SCHEDULED_SERVICES_CLEAR_CALENDAR_SELECTED_FILTER = 'SCHEDULED_SERVICES_CLEAR_CALENDAR_SELECTED_FILTER';
export const SCHEDULED_SERVICES_SET_CALENDARS_FILTERS = 'SCHEDULED_SERVICES_SET_CALENDARS_FILTERS';

export const SCHEDULED_SERVICES_FETCH_PLACES_CALENDAR_START = 'SCHEDULED_SERVICES_FETCH_PLACES_CALENDAR_START';
export const SCHEDULED_SERVICES_FETCH_PLACES_CALENDAR_SUCCESS = 'SCHEDULED_SERVICES_FETCH_PLACES_CALENDAR_SUCCESS';
export const SCHEDULED_SERVICES_FETCH_PLACES_CALENDAR_FAIL = 'SCHEDULED_SERVICES_FETCH_PLACES_CALENDAR_FAIL';

export const SCHEDULED_SERVICES_FETCH_CALENDAR_EVENTS_START = 'SCHEDULED_SERVICES_FETCH_CALENDAR_EVENTS_START';
export const SCHEDULED_SERVICES_FETCH_CALENDAR_EVENTS_SUCCESS = 'SCHEDULED_SERVICES_FETCH_CALENDAR_EVENTS_SUCCESS';
export const SCHEDULED_SERVICES_FETCH_CALENDAR_EVENTS_FAIL = 'SCHEDULED_SERVICES_FETCH_CALENDAR_EVENTS_FAIL';

export const SCHEDULED_SERVICES_CALENDAR_SELECT_EVENT = 'SCHEDULED_SERVICES_CALENDAR_SELECT_EVENT';

export const SCHEDULED_SERVICES_FETCH_SERVICES_BY_DAY_AND_COMPLETED_START = 'SCHEDULED_SERVICES_FETCH_SERVICES_BY_DAY_AND_COMPLETED_START';
export const SCHEDULED_SERVICES_FETCH_SERVICES_BY_DAY_AND_COMPLETED_SUCCESS = 'SCHEDULED_SERVICES_FETCH_SERVICES_BY_DAY_AND_COMPLETED_SUCCESS';
export const SCHEDULED_SERVICES_FETCH_SERVICES_BY_DAY_AND_COMPLETED_FAIL = 'SCHEDULED_SERVICES_FETCH_SERVICES_BY_DAY_AND_COMPLETED_FAIL';

export const SCHEDULED_SERVICES_CALENDAR_SOFT_DELETE_START = 'SCHEDULED_SERVICES_CALENDAR_SOFT_DELETE_START';
export const SCHEDULED_SERVICES_CALENDAR_SOFT_DELETE_SUCCESS = 'SCHEDULED_SERVICES_CALENDAR_SOFT_DELETE_SUCCESS';
export const SCHEDULED_SERVICES_CALENDAR_SOFT_DELETE_FAIL = 'SCHEDULED_SERVICES_CALENDAR_SOFT_DELETE_FAIL';

export const SCHEDULED_SERVICES_FETCH_CALENDAR_REPORT_START = 'SCHEDULED_SERVICES_FETCH_CALENDAR_REPORT_START';
export const SCHEDULED_SERVICES_FETCH_CALENDAR_REPORT_SUCCESS = 'SCHEDULED_SERVICES_FETCH_CALENDAR_REPORT_SUCCESS';
export const SCHEDULED_SERVICES_FETCH_CALENDAR_REPORT_FAIL = 'SCHEDULED_SERVICES_FETCH_CALENDAR_REPORT_FAIL';

//SCHEDULED SERVICES MODAL

export const SCHEDULED_SERVICES_MODAL_FETCH_USERS_START = 'SCHEDULED_SERVICES_MODAL_FETCH_USERS_START';
export const SCHEDULED_SERVICES_MODAL_FETCH_USERS_SUCCESS = 'SCHEDULED_SERVICES_MODAL_FETCH_USERS_SUCCESS';
export const SCHEDULED_SERVICES_MODAL_FETCH_USERS_FAIL = 'SCHEDULED_SERVICES_MODAL_FETCH_USERS_FAIL';

export const SCHEDULED_SERVICES_MODAL_POST_START = 'SCHEDULED_SERVICES_MODAL_POST_START';
export const SCHEDULED_SERVICES_MODAL_POST_SUCCESS = 'SCHEDULED_SERVICES_MODAL_POST_SUCCESS';
export const SCHEDULED_SERVICES_MODAL_POST_FAIL = 'SCHEDULED_SERVICES_MODAL_POST_FAIL';

export const SCHEDULED_SERVICES_MODAL_UPDATE_START = 'SCHEDULED_SERVICES_MODAL_UPDATE_START';
export const SCHEDULED_SERVICES_MODAL_UPDATE_SUCCESS = 'SCHEDULED_SERVICES_MODAL_UPDATE_SUCCESS';
export const SCHEDULED_SERVICES_MODAL_UPDATE_FAIL = 'SCHEDULED_SERVICES_MODAL_UPDATE_FAIL';


// ------ HYPERFLOW --------------------------------------------------------------------------
export const HYPERFLOW_CREDENTIALS_LOADED = 'HYPERFLOW_CREDENTIALS_LOADED';
export const HYPERFLOW_ACCESS_CHANGED = 'HYPERFLOW_ACCESS_CHANGED';

// ------ SERVICE DRAFTS ------------------------------------------------------------------------

export const SERVICE_DRAFTS_FETCH_START = 'SERVICE_DRAFTS_FETCH_START';
export const SERVICE_DRAFTS_FETCH_SUCCESS = 'SERVICE_DRAFTS_FETCH_SUCCESS';
export const SERVICE_DRAFTS_FETCH_FAIL = 'SERVICE_DRAFTS_FETCH_FAIL';
export const SERVICE_DRAFTS_CLEAR_FILTERS = 'SERVICE_DRAFTS_CLEAR_FILTERS';
export const SERVICE_DRAFTS_SET_FILTERS = 'SERVICE_DRAFTS_SET_FILTERS';
export const SERVICE_DRAFTS_FETCH_EQUIPMENTS_START = 'SERVICE_DRAFTS_FETCH_EQUIPMENTS_START';
export const SERVICE_DRAFTS_FETCH_EQUIPMENTS_SUCCESS = 'SERVICE_DRAFTS_FETCH_EQUIPMENTS_SUCCESS';
export const SERVICE_DRAFTS_FETCH_EQUIPMENTS_FAIL = 'SERVICE_DRAFTS_FETCH_EQUIPMENTS_FAIL';
export const SERVICE_DRAFTS_DELETE_DRAFT_START = 'SERVICE_DRAFTS_DELETE_DRAFT_START';
export const SERVICE_DRAFTS_DELETE_DRAFT_SUCCESS = 'SERVICE_DRAFTS_DELETE_DRAFT_SUCCESS';
export const SERVICE_DRAFTS_DELETE_DRAFT_FAIL = 'SERVICE_DRAFTS_DELETE_DRAFT_FAIL';
export const SERVICE_DRAFTS_SELECT_DRAFT_START = 'SERVICE_DRAFTS_SELECT_DRAFT_START';
export const SERVICE_DRAFTS_SELECT_DRAFT_SUCCESS = 'SERVICE_DRAFTS_SELECT_DRAFT_SUCCESS';
export const SERVICE_DRAFTS_SELECT_DRAFT_FAIL = 'SERVICE_DRAFTS_SELECT_DRAFT_FAIL';

